import React from 'react';
import ReactDOM from 'react-dom';
import FoldersPageContainer from '../React/src/views/FoldersPage/Folders/FoldersPageContainer';
import LibraryAwareTheme from "../React/src/layouts/Main/components/LibraryAwareTheme/LibraryAwareTheme";
import NavBarMain from '../React/src/layouts/Main/components/NavBar/NavBarMain';
import ProfileMenu from '../React/src/components/Menus/ProfileMenu/ProfileMenu';
import { folderRouteBuilder } from '../Backbone/folderRouteUtilities';
import * as Constants from "../React/src/data/StringConstants";

export default function Application(_, LA, Res) {
	// Function to determine if div has vertical scrollbar present
	$.fn.hasVScrollBar = function () {
		return this.get(0).scrollHeight > this.height();
	};

	/////////////////////////////////////////////////
	////////// GLOBAL VARIABLES & SETTINGS //////////
	/////////////////////////////////////////////////

	/**
	 * @description Indicate to Backbone to use standard HTTP requests... not REST.
	 * @kind Global Variable - Backbone:Configuration
	 */
	Backbone.emulateHTTP = true;
	/**
	 * @description The global jqXHR handler & result container. Wraps LA.ajax
	 * @kind Global Variable - jqXHR:HttpClient
	 */
	LA.jqXHR = null;

	/////////////////////////////////////////////////
	//////////////// GLOBAL FUNCTIONS ///////////////
	/////////////////////////////////////////////////

	/**
	 * @prviate
	 * @description Provides custom user experience for scrolling, depending on pagination state
	 * @kind Global Function - User Interface:Control
	 * @param  {jQueryHTMLElement} element - Focus of the scrolling action/evaluation
	 * @param  {Event} e - The event object
	 * @param  {object} pageFilter - Applied pageFilter object
	 * @param  {eventName} trigger - EventName to issue
	 */
	const commonScrollList = function (element, e, pageFilter, trigger) {
		if (element.models.Payload.get('PageCount') < element.models.Filter.get(pageFilter)) {
			e.stopPropagation();
		} else {
			var $el = $(e.currentTarget),
				scrollHeight = e.currentTarget.scrollHeight,
				scrollTop = $el.scrollTop(),
				outerHeight = $el.outerHeight();

			if (scrollHeight - scrollTop <= outerHeight + 100) {
				element.trigger(trigger);
			}
		}
	};

	/**
	 * @description Presents or maintains the "working" visual cue
	 * @kind Global Function - User Interface:VisualCue.External
	 */
	LA.showWorking = function () {
		var $working = $('#app-working');
		if ($working.length) {
			$working.show();
		} else {
			$('<div/>', { 'id': 'app-working', 'class': 'working' }).html('Working').appendTo('body').show();
		}
	};

	/**
	 * @description Hides the "working" visual cue if present
	 * @kind Global Function - User Interface:VisualCue
	 */
	LA.hideWorking = function () {
		var $working = $('#app-working');
		if ($working.length) { $working.hide().remove(); }
	};

	/**
	 * @description Extracts a collection of `templates` from the global variable LA.Templates if they match the given pattern
	 * @kind Global Function - User Interface:Filters-and-Reducers
	 * @param {Regex} pattern - The pattern used to qualify templates
	 * @returns {collection<template>} The collection of qualified templates
	 */
	LA.filterTemplates = function (pattern) {
		var templates = {};
		for (var t in LA.Templates) {
			if (LA.Templates.hasOwnProperty(t)) {
				if (!(pattern).test(t)) {
					continue;
				}
				templates[t.split('/')[1]] = LA.Templates[t];
			}
		}
		return templates;
	};

	/**
	   * @description Establishes and performs initial xhr requests, then hands off request to the formal LA.jqXHR object
	   * @param {object} options - The jQuery Ajax options object, used to define the request
	   * @param {function} done - The `done` function to use
	   * @param {function} complete - The `complete` function to use
	   * @summary More about jQuery AJAX here : https://api.jquery.com/jquery.ajax/
	   * @returns Reference to the Global Variable LA.jqXHR
	   */
	LA.ajax = function (options, done, complete) {
		var timeOut = false;
		// Cancel any AJAX request out there
		if (!_.isUndefined(LA.jqXHR) && !_.isNull(LA.jqXHR) && LA.jqXHR.readyState !== 4) {
			LA.jqXHR.abort();
		}
		// Make request
		LA.jqXHR = $.ajax(options);
		// Check for timeout JSON object.
		LA.jqXHR.done(function (resp) {
			// Check
			if (_.isObject(resp) && !_.isUndefined(resp.IsTimeout) && resp.IsTimeout) {
				timeOut = true;
				window.top.location = resp.Redirect;
			}
		});
		// Execute on success
		if (!timeOut && !_.isUndefined(done) && _.isFunction(done)) {
			LA.jqXHR.done(done);
		}
		// Execute always.
		if (!_.isUndefined(complete) && _.isFunction(done)) {
			LA.jqXHR.complete(complete);
		}

		return LA.jqXHR;
	};

	/**
	 * @description Applies visual cues to jQuery's ajax api
	 */
	$(document)
		.ajaxStart(LA.showWorking)
		.ajaxComplete(LA.hideWorking);

	/////////////////////////////////////////////////////////////////////////////
	////////////////////////////// Configure Mixins /////////////////////////////
	/////////////////////////////////////////////////////////////////////////////
	// LA.Mixins contains all functionalty commonly related to a given scope   //
	// of concern.Said concerns are delinated by object dot notation children  //
	/////////////////////////////////////////////////////////////////////////////
	//																																				 //	
	//									 TODO - Move this to its own module									   //
	//																																				 //
	/////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////


	/**
	 * @description Mixin functionality related to `App` concerns
	 */
	LA.Mixins.App = {
		/**
		 * @description Determines if the element which matches the `#content` selector
		 * has a given className or not, and whether or not the argument itself is valid
		 * @param {string} className - The class name to verify presence of
		 * @returns {boolean}
		 * @TODO : this could be rewritten simply as ` return  className ? $content.hasClass(className) : false `
		 */
		isRendered: function (className) {
			var $content = $('#content');
			if (_.isUndefined(className) || _.isNull(className)) {
				return false;
			}
			return $content.hasClass(className);
		}
	};
	/**
	 * @description Mixin functionality related to `View` concerns
	 */
	LA.Mixins.View = {
		/**
		 * @description Empties all views of their respective state/data
		 * @summary - Backbone.js Collection.reset : https://backbonejs.org/#Collection-reset
		 */
		resetChildren: function () {
			if (_.isArray(this.views)) {
				for (var i = 0; i < this.views.length; i++) {
					if (_.isFunction(this.views[i].reset)) {
						this.views[i].reset();
					}
				}
			}
		}
	};

	/**
	 * @description Mixin functionality related to the `Sidebar's Layout` concerns
	 */
	LA.Mixins.SideBarLayout = {
		/**
		 * @description Configures the dimensions of the sidebar based on 
		 */
		resizeContent: function () {
			var inlineStyles = this.$el.attr('style'),
				/**
				 * @description Separate individual inline-style declarations into simple sections,
				 * containing both the key and value, as a singular string
				 */
				rules = inlineStyles ? inlineStyles.split(';') : [],
				ruleParts,
				style = {},
				width,
				height,
				$container = this.$('.container-sidebar-layout'),
				$content = $container.find('#sidebar-content'),
				$nav = $container.find('#sidebar-nav');


			/**
			 * @TODO - rewrite this and simplify into a reduce
			 */
			for (var i = 0; i < rules.length; i++) {
				/**
				 * @description Separate the individual strings into a simple array containing only two indices
				 * ruleParts[0] = style attribute
				 * ruleParts[1] = style value
				 */
				ruleParts = rules[i].split(':');
				/**
				 * @description Establish the pair as a key value set via a multidimensional array
				 * @TODO - switch this to object notation instead of an array.
				 */
				style[$.trim(ruleParts[0])] = parseInt($.trim(ruleParts[1]), 10);
			}

			height = style.height - parseInt($container.css('margin-top'), 10);
			width = parseInt(this.$el.width(), 10);

			if ($nav.is(':visible')) {
				$content.css('margin-left', 240);
				width -= parseInt($content.css('margin-left'), 10);
			} else {
				$content.css('margin-left', 0);
			}

			$content
				.css('height', height)
				.css('width', width)
				.css('overflow', 'auto');
		},
		/**
		 * @description Clears out existing html elements and applies a fresh set
		 * @param {HTML} content - new content to place in the element which matches the `#sidebar-content` selector
		 * @param {*} cssRules - css declarations to apply to the new DOMFragment
		 */
		setContent: function (content, cssRules) {
			var css = $.extend({}, cssRules || {}),
				$div = $('<div/>').css(css);
			this.$('#sidebar-content')
				.empty()
				.append($div);
			$div.html(content);
		},
		/**
		 * @description Placeholder attribute(?)
		 */
		setBreadCrumbs: function () {
			// No Op, should be overridden
		}
	};

	/////////////////////////////////////////////////////////////////////////////
	// Configure Event Aggregator
	// TODO - Move this to its own module
	/////////////////////////////////////////////////////////////////////////////
	LA.Events.Aggregator = _.extend({}, Backbone.Events);
	// Define shortcut
	window.$E = function () {
		LA.Events.Aggregator.trigger.apply(LA.Events.Aggregator, arguments);
	};

	/////////////////////////////////////////////////////////////////////////////
	// Configure Models
	// TODO - Move this to its own module
	/////////////////////////////////////////////////////////////////////////////
	LA.Models.BreadCrumb = Backbone.Model.extend({
		defaults: {
			'text': '',
			'fragment': '',
			'static': false
		}
	});
	/*----------------*/
	LA.Models.Heading = Backbone.Model.extend({
		defaults: {
			'text': '',
			'fragment': '',
			'heading': ''
		}
	});
	/*----------------*/
	LA.Models.ComplexNav = Backbone.Model.extend({});
	/*----------------*/
	LA.Models.Count = Backbone.Model.extend({});
	/*----------------*/
	LA.Models.Filter = Backbone.Model.extend({});
	/*----------------*/
	LA.Models.Payload = Backbone.Model.extend({});
	/*----------------*/
	LA.Models.Promo = Backbone.Model.extend({
		defaults: {
			id: 0,
			orgId: 0,
			name: '',
			description: '',
			audience: '',
			created: '',
			correlationId: '',
		},
		urlRoot: LA.Path + '/Promotions/GetPromotion'
	});
	/*----------------*/
	LA.Models.NewsletterList = Backbone.Model.extend({
		defaults: {
			'id': null,
			'name': '',
			'isActive': true,
			creationtimestamp: '',
			updatedtimestamp: ''
		},
		urlRoot: LA.Path + '/NewsletterLists/GetListDetails'
	});
	/*----------------*/
	LA.Models.AdvanceList = Backbone.Model.extend({
		defaults: {
			'Month': null,
			'Year': null,
			'NewsletterListId': null
		}
	});
	/*----------------*/
	LA.Models.DeliveryType = Backbone.Model.extend({
		defaults: {
			'id': 0,
			'name': ''
		}
	});
	/*----------------*/
	LA.Models.FormatType = Backbone.Model.extend({
		defaults: {
			'name': ''
		}
	});
	/*----------------*/
	LA.Models.Template = Backbone.Model.extend({
		defaults: {
			'id': 0,
			'orgId': 0,
			'concept': '',
			'audience': '',
			'format': null,
			'style': '',
			'tags': null,
			'hasImage': '',
			'imagePath': '',
			'created': '',
			'createUrl': ''
		}
	});
	/*----------------*/
	LA.Models.Widget = Backbone.Model.extend({
		defaults: {
			'id': '',
			'orgId': 0,
			'format': '',
			'name': '',
			'width': 0,
			'height': 0,
			'formatId': null
		}
	});

	/////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////
	//                						Application State                            //
	/////////////////////////////////////////////////////////////////////////////
	//																																				 //	
	//									 TODO - Move this to its own module									   //
	//																																				 //
	/////////////////////////////////////////////////////////////////////////////

	/**
	 * @description All `Filter` related functionality as it relates to state management
	 */
	LA.ApplicationState.Filters = {
		_request: null,
		defaults: { DefaultPromotionUserStarFilter: '0', DefaultNewsletterListUserStarFilter: '0' },
		_filterValues: { DefaultPromotionUserStarFilter: '0', DefaultNewsletterListUserStarFilter: '0' },
		/**
		 * @description Provides properties from the application's state, related to filters
		 * @param {string || array} propertiesRequested - The property(ies) requested from state
		 * @param {boolean} forceReload - Whether or not to trigger a refresh/reload of filter state
		 * @returns {Promise.Resolve([propertiesRequested])} - Returns a resolved Promise, which data is
		 * a collection of the requested filter(s) state, organized as a bidimensional array where
		 * property keys are the indices and their contents are said property's present state value
		 * @todo - suggestion: simplify this and return an object instead of array
		 */
		getProperties: function (propertiesRequested, forceReload) {
			var self = this;

			if (!self._request || forceReload) {
				self.fetchFilterValues();
			}

			var deferred = $.Deferred();
			self._request.always(function () {

				if (typeof propertiesRequested === "string") {
					propertiesRequested = [propertiesRequested];
				}

				var retval = {};
				_.each(propertiesRequested, function (propertyRequested) {
					retval[propertyRequested] = self._filterValues[propertyRequested];
				});
				deferred.resolve(retval);
			});
			return deferred;
		},
		/**
		 * @description Acquires the filter option set from the API and applies the result data
		 * as the entirety of the LA.ApplicationState.Filter value.
		 */
		fetchFilterValues: function () {
			// makes an ajax request to retrieve the filter values
			var $this = LA.ApplicationState.Filters;
			$this._request = $.ajax({
				url: LibraryAware.Path + "/Accounts/GetUserFilterSettings",
				global: false,
				type: "GET",
				dateType: "json",
				success: function (respData) {
					$this._filterValues = respData;
				}
			});
		}
	};

	/**
	 * @description Immediately fetch filters on application launch
	 * @todo MOVE THIS TO A MORE APPROPRIATE PLACE, LIKE AN ENTRY POINT
	 */
	LA.ApplicationState.Filters.fetchFilterValues();

	/////////////////////////////////////////////////////////////////////////////
	// Configure Collections
	/////////////////////////////////////////////////////////////////////////////
	// TODO : MOVE TO OWN MODULE
	/////////////////////////////////////////////////////////////////////////////
	LA.Collections.BreadCrumbs = Backbone.Collection.extend({
		model: LA.Models.BreadCrumb
	});
	/*----------------*/
	LA.Collections.DeliveryTypes = Backbone.Collection.extend({
		model: LA.Models.DeliveryType,
		url: LA.Path + '/Templates/GetDeliveryTypes'
	});
	/*----------------*/
	LA.Collections.FormatTypes = Backbone.Collection.extend({
		model: LA.Models.FormatType,
		url: LA.Path + '/Templates/GetFormats'
	});
	/*----------------*/
	LA.Collections.TemplateTypes = Backbone.Collection.extend({
		model: LA.Models.Template,
		url: LA.Path + '/Templates/GetTemplates'
	});
	LA.Collections.WidgetTypes = Backbone.Collection.extend({
		model: LA.Models.Widget,
		url: LA.Path + "/Widgets/GetWidgets"
	});


	/////////////////////////////////////////////////////////////////////////////
	// Utility Functions
	/////////////////////////////////////////////////////////////////////////////
	// TODO : MOVE TO OWN MODULE
	/////////////////////////////////////////////////////////////////////////////

	/**
	   * @description flashes the background of element by applying a common transition class as well as the specified class(es)
	   * then waits for the transition to finish (at least long enough), and cleans up after itself
	   * @param {jQueryHTMLElement} element - jQuery wrapped HTMLElement to apply treatment to
	   * @param {string} cssClass - cssClass (or space separated classes) that control the background color/animation
	   */
	LA.flashBackground = function (element, cssClass) {
		element.addClass(cssClass);
		setTimeout(function () {
			element.addClass('background-animatable');
			element.removeClass(cssClass);
			setTimeout(function () {
				element.removeClass('background-animatable');
			}, 2000);
		}, 500);
	};

	/**
	 * @decription What?
	 */
	var flashBackground = LA.flashBackground;


	////////////////////////////////////////////////////////////
	///////////////  Copy Related Functionality  ///////////////
	////////////////////////////////////////////////////////////
	///////////////  TODO - MOVE TO OWN MODULE   ///////////////
	////////////////////////////////////////////////////////////


	//CopyIssue function used in the main Newsletter Overview page and also on the NewsletterListIssues page
	/**
	 * @description Invokes the Document Copy Modal user experience, found on both the main Newsletter 
	 * Overview page and the NewsLetter List Issues page
	 * @kind Newsletter Function - UserExperience:Modal
	 * @param {string} uiUrlEndpoint - The MVC endpoint which will supply the modal content
	 * @param {string} title - The title to give the modal 
	 * @param {string} okButtonText - The text to apply to the "OK" button label
	 * @param {function} onOk - The function to execute for acceptance of modal content
	 */
	var startCopy = function (uiUrlEndpoint, title, okButtonText, onOk) {
		var $copyModal = $('<div />');
		$copyModal.load(uiUrlEndpoint, function () {
			$copyModal.modal({
				width: 'auto',
				height: 'auto',
				zIndex: 100010,
				useActualContent: true,
				allowContentOverflow: true,
				title: title,
				show: true,
				buttons: [
					{
						text: okButtonText,
						click: function () {
							onOk(this);
						},
						'class': 'btn-warning'
					},
					{
						text: 'Cancel'
					}
				]
			});
		});
	};

	/**
	 * @description Duplicates an existing document. It is then furnished to the startCopy modal, and startCopy is initiated
	 * @param {string} documentId - the Id of the document desired to duplicate
	 * @returns {Promise} - 
	 * @todo - use of deferred in this manner is an antipattern. The $.post is already a promise result
	 */
	LA.copyDocument = function (documentId) {
		var deferred = $.Deferred();
		var copyUrl = LA.WebRoot + LA.OrganizationId + '/Documents/Copy/' + documentId;

		var doCopy = function (modal) {
			var newItemName = modal.find('#newItemName').val();
			var newContextId = modal.find("#newContextId").val();

			var postData = {
				name: newItemName,
				newContextId: newContextId
			};

			$.post(copyUrl, postData, function (data) {
				if (data.success) {
					modal.hide();
					//navigate to new context
					deferred.resolve(data);

				} else {
					modal.hide();
					$('<div class="error message" style="position: relative;">' + data.message + '</div>').modal({
						title: "Error Copying Document",
						useActualContent: true,
						width: '450px',
						show: true,
						buttons: [{
							text: "OK"
						}]
					});
					deferred.reject(data);
				}
			});
		};

		startCopy(copyUrl, "Copy and Move Document", "Copy and Move", doCopy);
		return deferred.promise();
	};

	/**
	 * @description What?
	 */
	var copyDocument = LA.copyDocument;

	/**
	 * @description Duplicates an existing NewsletterIssue. It is then furnished to the startCopy modal, and startCopy is initiated
	 * @param {string} issueId - ID of the issue to duplicate
	 * @param {*} _ - unused but positionally mandatory
	 * @param {function} callback - Function to execute upon success
	 */
	var copyNewsletterIssue = function (issueId, _, callback) {
		var copyUrl = LA.WebRoot + LA.OrganizationId + '/NewsletterIssues/Copy/' + issueId;

		var doCopy = function (modal) {
			var issueNewName = modal.find('#newIssueName').val();
			modal.find('#error').css('display', 'none');

			$.post(copyUrl, { newIssueName: issueNewName }, function (data) {
				var message = !data.success ? data.message : null;
				if (data.success) {
					callback(modal, data);
				}
				if (message) {
					modal.find('#error').css('display', 'block').text(message);
				}
			}, 'json');
		};

		startCopy(copyUrl, "Copy Newsletter Issue", "Copy Newsletter Issue", doCopy);
	};

	/////////////////////////////////////////////////////////////////////////////
	// Configure Views
	/////////////////////////////////////////////////////////////////////////////
	// TODO - MOVE EACH TO OWN MODULE
	/////////////////////////////////////////////////////////////////////////////

	/**
	 * @todo - MAKE OWN MODULE
	 */
	LA.Views.SupportDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Support\/Dashboard/);

			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:supportSideNav', setEvent: 'set:supportSideNavModel', showEvent: 'show:supportSideNav' }))
			];

			_.bindAll(this,
				'render',
				'renderCrumbsAndChild',
				'resize',
				'reset',
				'setContent');

			this.options.dispatcher
				.on('render:supportDashboard', this.render)
				.on('render:supportCrumbsAndChild', this.renderCrumbsAndChild)
				.on('resize:supportLayout', this.resize)
				.on('set:supportContent', this.setContent);
		},
		render: function (action) {
			var self = this,
				resizeHandler;
			this.options.dispatcher
				.trigger('set:content', '<div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'support-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			this.options.dispatcher
				.trigger('set:supportSideNavModel', { action: action });

			this.resizeContent();

			resizeHandler = _.debounce(function () { self.resizeContent(); }, 100);

			$(window).on('resize.sidebarContent', resizeHandler);
		},
		renderCrumbsAndChild: function (action, id) {
			var self = this, crumbs, url = LA.Path;

			this.options.dispatcher
				.trigger('add:crumb', { text: 'Support Dashboard', fragment: '#!/support' }, { isRoot: true });
			var bindF5 = false;

			switch (action) {
				case 'subscriber-management':
					crumbs = [{ text: 'Subscriber Management' }];
					url += '/AdminSubscriberManagement/Index';
					break;
				case 'email-support':
					crumbs = [{ text: 'Retry Eblast' }];
					url += '/EmailSupport/Index';
					break;
				case 'create-tag':
					crumbs = [{ text: 'Tags', fragment: '#!/support/tags' }, { text: 'Create Tag' }];
					url += '/Tags/Save';
					break;
				case 'edit-tag':
					crumbs = [{ text: 'Tags', fragment: '#!/support/tags' }, { text: 'Edit Tag' }];
					url += '/Tags/Save/' + id;
					break;
				case 'tags':
					crumbs = [{ text: 'Tags' }];
					url += '/Tags/Index';
					break;
				case 'create-hint':
					crumbs = [{ text: 'Document Editor Hints', fragment: '#!/support/editor-hints' }, { text: 'Create Hint' }];
					url += '/Hints/Save';
					break;
				case 'edit-hint':
					crumbs = [{ text: 'Document Editor Hints', fragment: '#!/support/editor-hints' }, { text: 'Edit Hint' }];
					url += '/Hints/Save/' + id;
					break;
				case 'editor-hints':
					crumbs = [{ text: 'Document Editor Hints' }];
					url += '/Hints/Index';
					break;
				case 'system-reports':
					crumbs = [{ text: 'Standard Reports' }];
					url += '/AdminReports/Index';
					break;
				case 'adhoc-reports':
					bindF5 = true;
					crumbs = [{ text: 'One-time Reports' }];
					url += '/AdminReports/AdHocReport';
					break;
				case 'create-style':
					crumbs = [{ text: 'Document Style Sheets', fragment: '#!/support/document-styles' }, { text: 'Create Style Sheets' }];
					url += '/Styles/Save';
					break;
				case 'edit-style':
					crumbs = [{ text: 'Document Style Sheets', fragment: '#!/support/document-styles' }, { text: 'Edit Style Sheets' }];
					url += '/Styles/Save/' + id;
					break;
				case 'document-styles':
					crumbs = [{ text: 'Document Style Sheets' }];
					url += '/Styles/Index';
					break;
				case 'application-settings':
					crumbs = [{ text: 'Application Settings' }];
					url += '/AppSettings/Edit';
					break;
				case 'email-verification-configuration':
					crumbs = [{ text: 'Email Verification Configuration' }];
					url += '/EmailVerification/Index';
					break;
				case 'disk-cacher':
					crumbs = [{ text: 'Disk Cacher' }];
					url += '/Administration/DiskCacher';
					break;
				case 'create-system-email':
					crumbs = [{ text: 'System Email Messages', fragment: '#!/support/system-emails' }, { text: 'Create Email' }];
					url += '/SystemEmailMessages/Save';
					break;
				case 'edit-system-email':
					crumbs = [{ text: 'System Email Messages', fragment: '#!/support/system-emails' }, { text: 'Edit Email' }];
					url += '/SystemEmailMessages/Save/' + id;
					break;
				case 'system-emails':
					crumbs = [{ text: 'System Email Messages' }];
					url += '/SystemEmailMessages/Index';
					break;
				case 'edit-organization':
					crumbs = [{ text: 'List Organizations', fragment: '#!/support/organizations' }, { text: 'Edit Organization' }];
					url += '/Organizations/AdminOrgEditor/' + id;
					break;
				case 'deactivate-organization':
					crumbs = [{ text: 'List Organizations', fragment: '#!/support/organizations' }, { text: 'Deactivate Organization' }];
					url += '/Organizations/DeactivateOrganization/' + id;
					break;
				case 'impersonate-user':
					crumbs = [{ text: 'List Organizations', fragment: '#!/support/organizations' }, { text: "Impersonate User" }];
					url += "/Session/ImpersonateUser/";
					break;
				case 'cataloging':
					crumbs = [{ text: 'Cataloging Terms', fragment: '#!/support/cataloging' }, { text: "Catalog Terms" }];
					url += "/CatalogingTerms/Index";
					break;
				case 'edit-cataloging':
					crumbs = [{ text: 'Cataloging Terms', fragment: '#!/support/cataloging' }, { text: 'Edit Cataloging Term' }];
					url += '/CatalogingTerms/Edit/' + id;
					break;
				default:
					crumbs = [{ text: 'List Organizations' }];
					url += '/Administration/ListOrganizations';
					break;
			}

			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});

			LA.ajax({ url: url, type: 'GET' }, function (resp) {
				self.setContent(resp, { 'padding': '0 10px 0 0' });
				if (bindF5) {
					$(window).on('keydown.adhocreports', function (e) {
						if (e.which === 116 && !e.ctrlKey) { //f5 (but not ctrl+F5)
							$("#show-results-button").click();
							e.preventDefault();
						}
					});
				} else {
					$(window).off('.adhocreports');
				}
			});
		},
		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:supportSideNav', bool);
			this.resizeContent();
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');
			$(window).off('.adhocreports');
			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
 * @todo - MAKE OWN MODULE
 */
	LA.Views.SupportContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.SupportDashboard(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
 * @todo - MAKE OWN MODULE
 */
	LA.Views.AdminDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Admin\/Dashboard/);
			this.galleryInfo = copyTemplateGalleryInfo;
			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:adminSideNav', setEvent: 'set:adminSideNavModel', showEvent: 'show:adminSideNav' })),
				new LA.Views.TemplateGallery($.extend({}, this.options, { models: this.models, galleryInfo: this.galleryInfo }))
			];
			this.widgetContext = { currentWidgetType: '' };

			_.bindAll(this,
				'render',
				'addRootCrumb',
				'renderCrumbs',
				'renderCrumbsAndChild',
				'renderWidgetSubsection',
				'resize',
				'reset',
				'setContent',
				"deauthorizeInstagramAccount");

			this.options.dispatcher
				.on('render:adminDashboard', this.render)
				.on('render:adminCrumbsAndChild', this.renderCrumbsAndChild)
				.on('resize:adminLayout', this.resize)
				.on('set:adminContent', this.setContent)
				.on('render:adminWidgetSubsection', this.renderWidgetSubsection)
				.on('deauthorize:instagramAccount', this.deauthorizeInstagramAccount);
		},

		deauthorizeInstagramAccount: function (checkedBoxes) {
			var doDeauthorization = function (checkedBoxes) {
				$.post(LA.Path + '/Organizations/DeauthorizeInstagramPage?orgId=' + LA.OrganizationId + "&accountsToDeauthorize=" + checkedBoxes, function (data) {
					if (data.success) {
						$('#instagram-pages tr').has('input[type="checkbox"]:checked').remove();
					}
				});
			};

			if (checkedBoxes.length > 0) {
				$('<div>' + Res.Strings.SocialMedia.confirmDeauthorization + '</div>').modal({
					title: 'Confirm Deauthorize',
					width: 350,
					height: 175,
					zIndex: 100010,
					backdrop: 'static',
					show: true,
					buttons: [
						{
							text: 'Yes',
							id: 'deauthorize-yes',
							click: function () {
								doDeauthorization(checkedBoxes);
								this.hide();
							}
						},
						{
							text: 'Cancel'
						}
					]
				});
			}	
		},

		render: function (action) {
			var self = this,
				resizeHandler;

			this.options.dispatcher
				.trigger('set:content', '<div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'admin-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			this.options.dispatcher
				.trigger('set:adminSideNavModel', { action: action });

			this.resizeContent();

			resizeHandler = _.debounce(function () { self.resizeContent(); }, 100);
			$(window).on('resize.sidebarContent', resizeHandler);
		},
		addRootCrumb: function () {
			this.options.dispatcher
				.trigger('add:crumb', { text: 'Admin', fragment: '#!/admin' }, { isRoot: true });
		},
		renderCrumbs: function (crumbs) {
			var self = this;
			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});
		},
		renderCrumbsAndChild: function (action, id) {
			var self = this, crumbs, url = LA.Path, args;
			var usePadding = true;
			this.addRootCrumb();

			switch (action) {
				case 'branding':
					crumbs = [{ text: 'Branding Sets' }];
					url += '/BrandingSets/Index';
					break;
				case 'access':
					crumbs = [{ text: 'Organization Access' }];
					url += '/Organizations/OrgAccess';
					break;
				case 'bulk-upload-files':
					crumbs = [{ text: 'Image Management', fragment: '#!/admin/images' }, { text: 'Bulk Upload' }];
					url += '/Files/BulkImageImport';
					break;
				case 'edit-image':
					crumbs = [{ text: 'Image Management', fragment: '#!/admin/images' }, { text: 'Edit Image' }];
					url += '/Files/Keywords/' + id;
					break;
				case 'images':
					crumbs = [{ text: 'Image Management' }];
					url += '/Organizations/UploadedImages';
					break;
				case 'activity':
					crumbs = [{ text: 'System Activity' }];
					url += '/Organizations/AuditLog';
					break;
				case 'social-accounts':
					crumbs = [{ text: 'Social Accounts' }];
					url += '/Organizations/SocialAccounts';
					break;
				case 'create-e-resource':
					crumbs = [{ text: 'E-Resources', fragment: '#!/admin/e-resources' }, { text: 'Create E-Resource' }];
					url += '/EResources/Save';
					break;
				case 'edit-e-resource':
					crumbs = [{ text: 'E-Resources', fragment: '#!/admin/e-resources' }, { text: 'Edit E-Resource' }];
					url += '/EResources/Save/' + id;
					break;
				case 'e-resources':
					crumbs = [{ text: 'E-Resources' }];
					url += '/EResources/Index';
					usePadding = false;
					break;
				case 'view-widget-posts':
					crumbs = [{ text: 'Widgets', fragment: "#!/admin/widgets'" }, { text: "View Widget Posts" }];
					url += "/Widgets/ViewPosts/" + id;
					break;
				case 'create-template':
					crumbs = [{ text: 'Templates', fragment: '#!/admin/templates' }, { text: 'Create Template' }];
					url += '/Templates/Save?editorType=' + id;
					break;
				case 'edit-template':
					crumbs = [{ text: 'Templates', fragment: '#!/admin/templates' }, { text: 'Edit Template' }];
					url += '/Templates/Save/' + id;
					break;
				case 'copy-template':
					crumbs = [{ text: 'Templates', fragment: '#!/admin/templates' }, { text: 'Copy Template' }];
					args = [self.galleryInfo.mainRenderEvent];
					break;
				case 'templates':
					crumbs = [{ text: 'Templates' }];
					url += '/Templates/Index';
					break;
				case 'section-layouts':
					crumbs = [{ text: 'Section Layouts' }];
					url += '/SectionLayout/Index';
					break;
				case 'font-swatches':
					crumbs = [{ text: 'Font Swatches' }];
					url += '/Swatches/FontsIndex';
					break;
				case 'color-swatches':
					crumbs = [{ text: 'Color Swatches' }];
					url += '/Swatches/ColorsIndex';
					break;
				case 'custom-fonts':
					crumbs = [{ text: 'Custom Fonts' }];
					url += '/Fonts/';
					break;
				case 'import-export':
					crumbs = [{ text: 'Import/Export Content' }];
					url += '/Organizations/ImportExport';
					break;
				case 'content-availability':
					crumbs = [{ text: 'Content Availability' }];
					url += '/Organizations/ContentAvailability';
					break;
				case 'advance':
					crumbs = [{ text: 'Advanced Settings' }];
					url += "/NewsletterLists/BulkNewsletterListsIndex";
					break;
				case 'edit-opt-in-config':
					crumbs = [{ text: 'Edit Opt-In Configuration' }];
					url += "/Organizations/EditOptInPageConfiguration";
					break;
				case 'data-sources':
					crumbs = [{ text: 'Data Sources' }];
					url += "/DataSources/Index";
					break;
				default:
					// If the User is a Publisher, they are only allowed to view the "Templates" section in the Admin Dashboard. 
					// In the case a Publisher is logged in, if they click the "Admin" root breadcrumb, they will land here in the Default
					// case, so we redirect them to the Templates page.
					if (LA.Security.isPublisher && !LA.Security.isAdmin) {
						crumbs = [{ text: 'Templates' }];
						url += '/Templates/Index';
					} else {
						crumbs = [{ text: 'Basic Settings' }];
						url += '/Organizations/BasicSettings';
					}
					break;
			}

			self.renderCrumbs(crumbs);
			if (args) {
				this.options.dispatcher.trigger.apply(this.options.dispatcher, args);
			} else {
				LA.ajax({ url: url, type: 'GET' }, function (resp) {
					self.setContent(resp, usePadding ? { 'padding': '0 10px 0 0' } : {});
				});
			}
		},
		renderWidgetSubsection: function (type, action, id, promoId) {
			var self = this, crumbs, url = LA.Path;
			//default parameters to logical values
			type = type || "promotion";
			action = action || "index";

			var descriptor = "";
			if (type === "promotion") {
				descriptor = "";
			} else if (type === "newsletter") {
				descriptor = "Newsletter";
			}

			this.addRootCrumb();
			switch (action) {
				case "index":
					url += '/Widgets/Index';
					crumbs = [{ text: descriptor + ' Widgets' }];
					self.widgetContext.currentWidgetType = '';
					break;
				default:
					url += '/Widgets/Index';
					crumbs = [{ text: descriptor + ' Widgets' }];
					self.widgetContext.currentWidgetType = '';
					break;
				case "edit":
					url += "/Widgets/Edit/" + id;
					crumbs = [{ text: descriptor + ' Widgets', fragment: "#!/admin/widgets/" + type }, { text: "Edit Widget" }];
					self.widgetContext.currentWidgetType = '';
					break;
				case "createwidgetforpost":
					url += "/Widgets/CreateWidgetForPost/" + id + "/" + promoId
					crumbs = [{ text: descriptor + ' Widgets', fragment: "#!/admin/widgets/" + type }, { text: "Create Widget" }];
					self.widgetContext.currentWidgetType = '';
					break;
				case "create":

					crumbs = [{ text: descriptor + ' Widgets', fragment: "#!/admin/widgets/" + type }, { text: "Create Widget", fragment: "#!/admin/widgets/" + type + "/create" }];
					/**
					 * @todo - Create an endpoint on the server to furnish widget types and their respective descriptions and IDs, then remove the switch statement
					 * @todo - write a story to capture this work
					 */
					switch (id) {
						case 'SingleBookJacket':
							crumbs.push({ text: 'Single Book Jacket', fragment: '' });
							url += "/Widgets/CreateNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;
						case 'MultipleBookJacket':
							crumbs.push({ text: 'Multiple Book Jacket', fragment: '' });
							url += "/Widgets/CreateNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;
						case 'ArchiveLinks':
							crumbs.push({ text: 'Archive Links', fragment: '' });
							url += "/Widgets/CreateNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;
						case 'NewsletterIssue':
							crumbs.push({ text: 'Newsletter Issue', fragment: '' });
							url += "/Widgets/CreateNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;
						case 'MultipleBookJacketDetailView':
							crumbs.push({ text: 'Multiple Book Jacket with Detail View', fragment: '' });
							url += "/Widgets/CreateNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;
						case 'SingleBookJacketResponsive':
							crumbs.push({ text: 'Single Responsive Book Jacket', fragment: '' });
							url += "/Widgets/CreateResponsiveNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;

						case 'MultipleBookJacketResponsive':
							crumbs.push({ text: 'Multiple Responsive Book Jacket', fragment: '' });
							url += "/Widgets/CreateResponsiveNewsletterWidget?widgetType=" + id;
							self.widgetContext.currentWidgetType = id;
							break;
						default:
							url += "/Widgets/Create?widgetTypeDiscriminator=" + self.widgetContext.currentWidgetType;
					}
					break;
			}
			self.renderCrumbs(crumbs);

			LA.ajax({ url: url, type: 'GET', data: { widgetType: type } }, function (resp) {
				self.setContent(resp, { 'padding': '0 10px 0 0' });
			});
		},
		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:adminSideNav', bool);
			this.resizeContent();
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');

			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MAKE OWN MODULE
	 */
	LA.Views.AdminContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.AdminDashboard(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MAKE OWN MODULE
	 */
	LA.Views.ReportsDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Reports\/Dashboard/);

			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:reportsSideNav', setEvent: 'set:reportsSideNavModel', showEvent: 'show:reportsSideNav' })),
				new LA.Views.ReportPromotionSchedule($.extend({}, this.options, { template: this.templates.DashboardPromotionSchedule, models: this.models })),
				new LA.Views.NewsletterSubscriptionHistory($.extend({}, this.options, { template: this.templates.DashboardNewsletterSubscriptionHistory, models: this.models }))
			];

			_.bindAll(this, 'render', 'renderCrumbsAndChild', 'resize', 'reset', 'setContent');

			this.options.dispatcher
				.on('render:reportsDashboard', this.render)
				.on('render:reportsCrumbsAndChild', this.renderCrumbsAndChild)
				.on('resize:reportsLayout', this.resize)
				.on('set:reportsContent', this.setContent);
		},
		render: function (action) {
			var self = this,
				resizeHandler;

			this.options.dispatcher
				.trigger('set:content', '<div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'reports-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			this.options.dispatcher
				.trigger('set:reportsSideNavModel', { action: action });

			this.resizeContent();

			resizeHandler = _.debounce(function () { self.resizeContent(); }, 100);
			$(window).on('resize.sidebarContent', resizeHandler);
		},
		renderCrumbsAndChild: function (action) {
			var self = this;
			var crumbs;
			var args;
			var view;

			this.options.dispatcher
				.trigger('add:crumb', { text: 'Reports', fragment: '#!/reports' }, { isRoot: true });
			/**
			 * @todo - Suggestion: Manage these strings as a config const elsewhere
			 */
			switch (action) {
				case 'newslettersendhistory':
					crumbs = [{ text: 'Newsletter Send History' }];
					view = 'NewsletterSendHistory';
					break;
				case 'newslettersubscriptionhistory':
					crumbs = [{ text: 'Newsletter Subscription History' }];
					args = ['render:newsletterSubscriptionHistory'];
					break;
				case 'overview':
					crumbs = [{ text: 'Metrics' }];
					view = 'OverviewView';
					break;
				case 'communication-summary':
					crumbs = [{ text: 'Communication Summary' }];
					view = 'CommunicationSummaryView';
					break;
				default:
					crumbs = [{ text: 'Schedule' }];
					args = ['render:reportPromotionSchedule'];
					break;
			}

			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});

			if (args) {
				this.options.dispatcher
					.trigger.apply(this.options.dispatcher, args);
			} else if (view) {
				LA.ActiveView = new LA.Views[view]();
			}
		},
		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:reportsSideNav', bool);
			this.resizeContent();
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');

			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MAKE OWN MODULE
	 */
	LA.Views.ReportsContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.ReportsDashboard(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
 * @todo - MAKE OWN MODULE
 */
	LA.Views.ReportPromotionSchedule = Backbone.View.extend($.extend({}, LA.Mixins.View, {
		/**
		 * @todo - revisit event naming conventions
		 */
		events: {
			'change .orgLevel-publications .chosen-control select': 'updateFilters',
			'liszt:ready .publications-overview .control-ribbon select': 'addCustomLabel',
			'filterChanged .orgLevel-publications': 'filterChanged'
		},
		initialize: function (options) {
			this.options = options;
			this.template = options.template;
			this.models = $.extend({},
				options.models, {
				Filter: new LA.Models.Filter(),
				Payload: new LA.Models.Payload()
			});

			_.bindAll(this,
				'render',
				'resizePosts',
				'scrollList',
				'fetchItems',
				'displayItems',
				'addCustomLabel',
				'filterChanged',
				'updateFilters',
				'setFilter',
				'reset');

			//Define globally accessible events for this view
			this.options.dispatcher
				.on('render:reportPromotionSchedule', this.render)
				.on('update:PromotionScheduleFilters', this.updateFilters);

			this.on('fetch:items', this.fetchItems);

			//Define events for the models of this view
			this.models.Filter.on('change', this.fetchItems);
			this.models.Payload.on('change', this.displayItems);
		},
		render: function () {
			var self = this,
				resizeHandler,
				scrollHandler,
				keyUpHandler;

			//Ajax call to load the partial view "_OrgLevelPublicationSchedule"
			LA.ApplicationState.Filters.getProperties('DefaultPromotionUserStarFilter').done(function (properties) {
				LA.ajax({
					url: LA.Path + '/Posts/GetOrganizationPublicationSchedule',
					type: 'GET',
					data: { orgId: LA.OrganizationId }
				},
					/**
						  * @todo - Break this Resolve callback out into a separate function for testability purposes
						*/
					function (resp) {
						self.$el.empty().html(resp);
						self.models.Filter.clear({ silent: true });
						self.models.Filter.set({ pageNum: 1, pageSize: 12, firstTimeRender: true, starFilterType: properties.DefaultPromotionUserStarFilter });
						self.resizePosts();
						$('.orgLevel-publications [data-userstarfilter] [data-starvalue="' + properties.DefaultPromotionUserStarFilter + '"]').addClass('active').siblings().removeClass('active');
					},
					/**
						  * @todo - Break this Reject callback out into a separate function for testability purposes
						*/
					function () {
						//Create debounced versions of the event handlers
						resizeHandler = _.debounce(function () { self.resizePosts(); }, 100);
						scrollHandler = _.debounce(function (e) { self.scrollList(e); }, 300);
						keyUpHandler = _.debounce(function () { self.updateFilters(); }, 250);

						//Delegate debounced event handlers to desired events
						$(window).on('resize.items', resizeHandler);
						self.$('#posts')
							.on('scroll.posts', scrollHandler)
							.on('scroll.posts', _.throttle(function () {
								$('.widget-post', self.$el).qtip('toggle', false);
							}, 300));
						self.$('#search-box').on('keyup', keyUpHandler);
					});
			});

		},
		resizePosts: function () {
			this.$('#posts')
				.css('height', this.$el.height() - this.$('.row-fluid.heading').height());
			//Adjust filters' width based on screen resolution
			this.AdjustLabelWidth();
		},
		scrollList: function (e) {
			/**
			 * @todo - update reference here to external module once that work completed
			 */
			commonScrollList(this, e, 'pageNum', 'fetch:items');
		},
		fetchItems: function () {
			var self = this;
			if (_.isUndefined(self.models.Filter.get('startDate')) || _.isUndefined(self.models.Filter.get('endDate'))) {
				self.models.Filter.set({
					startDate: $('.date-picker #StartDate').val(),
					endDate: $('.date-picker #EndDate').val()
				}, { silent: true }
				);
			}
			//Load the data, and the list of social accounts simultaneously.
			async.parallel([
				function (callback) {
					//Ajax call to get the data to be loaded into the template
					LA.ajax({
						url: LA.Path + '/Posts/GetPublicationsSchedule',
						type: 'GET',
						data: self.models.Filter.toJSON(),
						dataType: 'json'
					}, function (resp) {
						callback(null, resp);
					});
				},
				LA.Utility.validateSocialMediaCache
			],
				function (err, results) {
					if (!err) {
						var resp = results[0];
						// We always want to trigger the change event, so clear the model silently then set to force change.
						self.models.Payload.clear({ silent: true });
						self.models.Payload.set(resp);
					}
				});
		},
		displayItems: function () {
			var pageNum = this.models.Filter.get('pageNum');
			var doRender = pageNum === 1;
			var payload = this.models.Payload.toJSON();
			var filter = this.models.Filter.toJSON();
			var tmplData = {
				data: payload.Data,
				filters: {
					isSearch: filter.isSearch,
					pageNum: filter.pageNum,
					pageSize: filter.pageSize,
					pageCount: payload.pageCount,
					isFirstPage: payload.IsFirstPage,
					isLastPage: payload.IsLastPage,
					hasPreviousPage: payload.HasPreviousPage,
					hasNextPage: payload.HasNextPage,
					totalItemCount: payload.TotalItemCount,
					starFilterType: filter.starFilterType
				}
			};

			if (doRender) {
				this.$('#publication-schedule-list').empty().html(this.template({ data: { starFilterType: filter.starFilterType, items: tmplData.data } }));
			}
			else {
				this.$('#publication-schedule-list').append(this.template({ data: { starFilterType: filter.starFilterType, items: tmplData.data } }));
			}

			this.models.Filter.set({ 'pageNum': ++pageNum }, { silent: true });

		},
		addCustomLabel: function (e) {
			prependLabelToChosenControl(e);
		},
		AdjustLabelWidth: function () {

			var filterRowWidth = $('div.row2').width();
			$('span.chzn-custom-label').each(function () {

				var selectedValue = $(this).siblings('span').val();
				if ($(this).hasClass('filterLabel')) {
					selectedValue = $(this).siblings('span').attr('data-val');
				}
				if (filterRowWidth < 750 && selectedValue !== "") {
					$(this).removeClass('shownCustomLabel').addClass('hiddenCustomLabel');
				}
				else {
					$(this).removeClass('hiddenCustomLabel').addClass('shownCustomLabel');
				}
			});
			if (filterRowWidth < 750) {
				this.$('select[id*="SelectChannelType"]').width('110px');
				this.$('div[id*="SelectChannelType"]').width('110px');
				this.$('select[id*="SelectCreator"]').width('140px');
				this.$('div[id*="SelectCreator"]').width('140px');
			}
			else {
				this.$('select[id*="SelectChannelType"]').width('160px');
				this.$('div[id*="SelectChannelType"]').width('160px');
				this.$('select[id*="SelectCreator"]').width('190px');
				this.$('div[id*="SelectCreator"]').width('190px');
			}

		},
		filterChanged: function (evt) {
			var filterValues = {
				starFilterType: evt.filterValue,
				pageNum: 1
			};

			this.setFilter(filterValues);
		},
		updateFilters: function (e) {
			var contextId = this.$('span.selected-Promotion').attr('data-val');
			var channelType = this.$('#SelectChannelType').val();
			var creator = this.$('#SelectCreator').val();
			var searchTerm = this.$('#search-box').val();
			var startDate = $('.date-picker #StartDate').val();
			var endDate = $('.date-picker #EndDate').val();

			var filterValues = {
				contextId: (_.isUndefined(contextId) ? null : contextId),
				channelType: (_.isUndefined(channelType) ? null : channelType),
				creator: (_.isUndefined(creator) ? null : creator),
				searchTerm: (_.isUndefined(searchTerm) ? null : searchTerm),
				startDate: (_.isUndefined(startDate) ? null : startDate),
				endDate: (_.isUndefined(endDate) ? null : endDate),
				pageNum: 1
			};

			this.setFilter(filterValues);

			if (e !== undefined) { this.addCustomLabel(e); }
		},
		setFilter: function (data, options) {
			this.models.Filter.set(data, $.extend({}, { silent: false }, options));
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.posts');
			this.$('#posts').off('scroll.posts');

		}
	}));

	/**
	 * @todo - MAKE OWN MODULE
	 */
	LA.Views.NewsletterSubscriptionHistory = Backbone.View.extend($.extend({}, LA.Mixins.View, {
		events: {
			'change #subscriptions-date-range-filter': 'updateFilters',
			'click #subscriptions-csv-export': 'csvExport',
			'filterChanged .newsletter-subscription-history #userStarFilter': 'filterChanged'
		},
		initialize: function (options) {
			this.options = options;
			this.template = options.template;
			this.models = $.extend({},
				options.models, {
				Filter: new LA.Models.Filter(),
				Payload: new LA.Models.Payload()
			});

			_.bindAll(this,
				'render',
				'csvExport',
				'resizePosts',
				'fetchItems',
				'displayItems',
				'filterChanged',
				'updateFilters',
				'setFilter',
				'reset');

			//Define globally accessible events for this view
			this.options.dispatcher
				.on('render:newsletterSubscriptionHistory', this.render)
				.on('update:newsletterSubscriptionHistoryFilters', this.updateFilters);

			this.on('fetch:items', this.fetchItems);

			//Define events for the models of this view
			this.models.Filter.on('change', this.fetchItems);
			this.models.Payload.on('change', this.displayItems);
		},
		render: function () {
			var self = this,
				resizeHandler;

			//Ajax call to load the partial view
			LA.ApplicationState.Filters.getProperties('DefaultNewsletterListUserStarFilter').done(function (properties) {
				LA.ajax({
					url: LA.Path + '/Subscribers/GetNewsletterSubscriptionHistoryIndex',
					type: 'GET',
					data: { orgId: LA.OrganizationId }
				}, function (resp) {
					self.$el.empty().html(resp);
					self.models.Filter.clear({ silent: true });
					self.models.Filter.set({ pageNum: 1, starFilterType: properties.DefaultNewsletterListUserStarFilter });
					self.resizePosts();
					$('.newsletter-subscription-history [data-userstarfilter] [data-starvalue="' + properties.DefaultNewsletterListUserStarFilter + '"]')
						.addClass('active').siblings().removeClass('active');
				}, function () {
					//Create debounced versions of the event handlers
					resizeHandler = _.debounce(function () { self.resizePosts(); }, 100);

					//Delegate debounced event handlers to desired events
					$(window).on('resize.items', resizeHandler);
				});
			});
		},
		csvExport: function (e) {
			e.preventDefault();
			window.location = LA.Path + '/Subscribers/GetNewsletterSubscriptionHistoryDetailsCsv?' + $.param(this.models.Filter.attributes);
		},
		resizePosts: function () {
			this.$('#newsletter-subscription-list')
				.css('height', this.$el.outerHeight() - this.$('.row-fluid.heading').outerHeight() - this.$('.row-fluid.filters').outerHeight() - this.$('.grid-header').outerHeight());
		},
		fetchItems: function () {
			var self = this;
			this.$('#newsletter-subscription-list').empty().html('<div class="no-issues">Loading data...</div>');
			//Ajax call to get the data to be loaded into the template
			LA.ajax({
				url: LA.Path + '/Subscribers/GetNewsletterSubscriptionHistoryDetails',
				type: 'GET',
				data: this.models.Filter.toJSON(),
				dataType: 'json'
			}, function (resp) {
				// We always want to trigger the change event, so clear the model silently then set to force change.
				self.models.Payload.clear({ silent: true });
				self.models.Payload.set(resp);
			});
		},
		displayItems: function () {
			var payload = this.models.Payload.toJSON();
			var tmplData = {
				data: payload.Data
			};

			this.$('#newsletter-subscription-list').empty().html(this.template({ data: tmplData.data }));
		},
		filterChanged: function (evt) {
			var filterValues = {
				starFilterType: evt.filterValue
			};

			this.setFilter(filterValues);
		},
		updateFilters: function () {
			var dates = $('#subscriptions-date-range-filter').data('dateRangeSelector') ? $('#subscriptions-date-range-filter').data('dateRangeSelector').getValues() : null;
			this.setFilter(dates);
		},
		setFilter: function (data, options) {
			this.models.Filter.set(data, $.extend({}, { silent: false }, options));
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.newsletter-subscription-list');
		}
	}));
	/*----------------*/
	/**
	 * @todo - MAKE OWN MODULE
	 */
	LA.Views.SubscribersDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Subscribers\/Dashboard/);
			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:subscriberSideNav', setEvent: 'set:subscriberSideNavModel', showEvent: 'show:subscriberSideNav' }))
			];

			_.bindAll(this, 'render', 'renderCrumbsAndChild', 'reset', 'resize', 'setContent');

			this.options.dispatcher
				.on('render:subscriberDashboard', this.render)
				.on('render:subscriberCrumbsAndChild', this.renderCrumbsAndChild)
				.on('resize:subscriberLayout', this.resize)
				.on('set:subscriberContent', this.setContent);
		},
		render: function (action) {
			var self = this,
				resizeHandler;

			this.options.dispatcher
				.trigger('set:content', '<div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'subscribers-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			this.options.dispatcher
				.trigger('set:subscriberSideNavModel', { action: action });

			this.resizeContent();

			resizeHandler = _.debounce(function () {
				self.resizeContent();
				$('#multifilter-input_chzn').css('width', '100%');
			}, 100);

			$(window).on('resize.sidebarContent', resizeHandler);
		},
		renderCrumbsAndChild: function (action, id, filterString) {
			var self = this, crumbs, url = LA.Path;
			var usePadding = true;

			var queryData = {};
			this.options.dispatcher
				.trigger('add:crumb', { text: 'Subscribers', fragment: '#!/subscribers' }, { isRoot: true });

			switch (action) {
				case 'create-segment':
					crumbs = [{ text: 'Subscriber Interest Groups', fragment: '#!/subscribers/segments' }, { text: 'Create Interest Group' }];
					url += '/SubscriberSegments/Create';
					break;
				case 'edit-segment':
					crumbs = [{ text: 'Subscriber Interest Groups', fragment: '#!/subscribers/segments' }, { text: 'Edit Interest Group' }];
					url += '/SubscriberSegments/Edit/' + id;
					break;
				case 'transfer-segment':
					crumbs = [{ text: 'Subscriber Interest Groups', fragment: '#!/subscribers/segments' }, { text: 'Transfer Subscribers' }];
					url += '/EmailSubscribers/TransferSubscribers/' + id;
					break;
				case 'segments':
					crumbs = [{ text: 'Subscriber Interest Groups' }];
					url += '/SubscriberSegments/Index';
					usePadding = false;
					break;
				case 'create-community-partner':
					crumbs = [{ text: 'Community Partners', fragment: '#!/subscribers/community-partners' }, { text: 'Create Community Partner' }];
					url += '/CommunityPartners/Create';
					break;
				case 'edit-community-partner':
					crumbs = [{ text: 'Community Partners', fragment: '#!/subscribers/community-partners' }, { text: 'Edit Community Partner' }];
					url += '/CommunityPartners/Edit/' + id;
					break;
				case 'community-partners':
					crumbs = [{ text: 'Community Partners' }];
					url += '/CommunityPartners/Index';
					break;
				case 'create-media-outlet':
					crumbs = [{ text: 'Media Outlets', fragment: '#!/subscribers/media-outlets' }, { text: 'Create Media Outlet' }];
					url += '/MediaOutlets/Create';
					break;
				case 'edit-media-outlet':
					crumbs = [{ text: 'Media Outlets', fragment: '#!/subscribers/media-outlets' }, { text: 'Edit Media Outlet' }];
					url += '/MediaOutlets/Edit/' + id;
					break;
				case 'media-outlets':
					crumbs = [{ text: 'Media Outlets' }];
					url += '/MediaOutlets/Index';
					break;
				case 'create-subscriber':
					crumbs = [{ text: 'Email Subscribers', fragment: '#!/subscribers/email' }, { text: 'Create Email Subscriber' }];
					url += '/EmailSubscribers/Create';
					break;
				case 'edit-subscriber':
					crumbs = [{ text: 'Email Subscribers', fragment: '#!/subscribers/email' }, { text: 'Edit Email Subscriber' }];
					url += '/EmailSubscribers/Edit/' + id;
					break;
				case 'bulk-add-subscribers':
					crumbs = [{ text: 'Email Subscribers', fragment: '#!/subscribers/email' }, { text: 'Bulk Upload Email Subscribers' }];
					url += '/EmailSubscribers/BulkUpload';
					queryData.viewMode = 0;
					break;
				case 'bulk-add-deactivated':
					crumbs = [{ text: 'Deactivated Subscribers', fragment: '#!/subscribers/deactivated' }, { text: 'Bulk Upload Email Subscribers' }];
					url += '/EmailSubscribers/BulkUpload';
					queryData.viewMode = 1;
					break;
				case 'optinpages':
					crumbs = [{ text: 'Opt-In Pages' }];
					url += '/CustomOptInPages/Index';
					break;
				case 'create-optinpage':
					crumbs = [{ text: 'Opt-In Pages', fragment: '#!/subscribers/optinpages' }, { text: 'Create Opt-In Page' }];
					url += '/CustomOptInPages/Edit';
					break;
				case 'edit-optinpage':
					crumbs = [{ text: 'Opt-In Pages', fragment: '#!/subscribers/optinpages' }, { text: 'Edit Opt-In Page' }];
					url += '/CustomOptInPages/Edit/' + id;
					break;
				case 'deactivated':
					crumbs = [{ text: 'Deactivated Subscribers' }];
					url += '/EmailSubscribers/Index';
					queryData.Mode = 1;
					break;
				case 'pending':
					crumbs = [{ text: 'Pending Subscribers' }];
					url += '/EmailSubscribers/Index';
					queryData.Mode = 2;
					break;
				case 'bulk-upload-history':
					crumbs = [{ text: 'Bulk Upload History', fragment: '#!/subscribers/bulk-upload-history' }];
					if (id) {
						url += '/EmailSubscribers/BulkImportDetails';
						crumbs.push({ text: "Upload Details" });
						queryData.BulkImportFileId = id;
					} else {
						this.views[0].select('bulk-upload-history');
						url += '/EmailSubscribers/BulkImportDetailsIndex';
					}
					break;
				default: //'email'
					action = "email";
					queryData.Mode = 0;
					crumbs = [{ text: 'Active Subscribers' }];
					url += '/EmailSubscribers/Index';
					break;
			}

			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});

			LA.ajax({ url: url, type: 'GET', data: queryData }, function (resp) {
				self.setContent(resp, usePadding ? { 'padding': '0 10px 0 0' } : {});

				var segmentIds = [];
				var newsletterListGuids = [];

				//At this point, we can jump in and set our default filters.
				if (action === 'email' || action === 'deactivated' || action == 'pending') {
					if (filterString) {
						var filters = filterString.split('/');
						var parts;

						for (var idx = 0; idx < filters.length; idx++) {
							//Slice up our filters.
							//They'll be of the form IG:SEGMENT_ID
							//or NL:NEWSLIST_GUID
							parts = filters[idx].split(':');
							if (parts.length > 1) {
								if (parts[0] === 'IG') {
									segmentIds.push(parts[1]);
								} else {
									newsletterListGuids.push(parts[1]);
								}
							}
						}
					}

					//This if *should* be unnecessary, since we know we just successfully
					//AJAX loaded the script which defines it, but it makes JSLint happy.
					if (LA.Subscribers.Email) {
						LA.Subscribers.Email.setFilters(segmentIds, newsletterListGuids);
					}

				}
			});
		},
		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:subscriberSideNav', bool);
			this.resizeContent();
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');

			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.SubscribersContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.SubscribersDashboard(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/

	/* Dashboard for the main Newsletters view */
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.NewslettersDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Newsletters\/Dashboard/);
			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:newslettersSideNav', setEvent: 'set:newslettersSideNavModel', showEvent: 'show:newslettersSideNav' })),
				new LA.Views.NewsletterListItems($.extend({}, this.options, { template: this.templates.DashboardListItems, models: this.models })),
				new LA.Views.AdvanceListOverview($.extend({}, this.options, { template: this.templates.DashboardListItems, models: this.models })),
				new LA.Views.NewsletterListsOverview($.extend({}, this.options, { template: this.templates.DashboardListsOverview, models: this.models }))
			];

			_.bindAll(this, 'render', 'renderCrumbsAndChild', 'resize', 'reset', 'setContent');

			this.options.dispatcher
				.on('render:newslettersDashboard', this.render)
				.on('render:newslettersCrumbsAndChild', this.renderCrumbsAndChild)
				.on('resize:newslettersLayout', this.resize)
				.on('set:newslettersContent', this.setContent);
		},
		render: function (action) {
			var self = this,
				resizeHandler;

			this.options.dispatcher
				.trigger('set:content', '<div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'newsletters-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			this.options.dispatcher
				.trigger('set:newslettersSideNavModel', { action: action });

			this.resizeContent();

			resizeHandler = _.debounce(function () { self.resizeContent(); }, 100);

			$(window).on('resize.sidebarContent', resizeHandler);
		},
		renderCrumbsAndChild: function (action) {
			var self = this, crumbs, args;

			this.options.dispatcher
				.trigger('add:crumb', { text: 'Newsletters', fragment: '#!/newsletters' }, { isRoot: true });

			switch (action) {
				case 'current-lists':
					crumbs = [{ text: 'Current Lists' }];
					args = ['render:newsletterListItems'];
					break;
				case 'advance-list':
					crumbs = [{ text: 'Advance List' }];
					args = ['render:advanceListOverview'].concat(arguments.slice ? arguments.slice(1) : Array.prototype.slice.call(arguments, 1));
					break;
				case "upload-list":
					crumbs = [{ text: 'Advance List', fragment: '#!/newsletters/advance-list' }, { text: 'Upload Advance List' }];
					args = ['render:advanceListUpload'];
					break;

				case 'overview':
					crumbs = [{ text: 'Overview' }];
					args = ['render:newsletterListsOverview'];
					break;
				default:
					crumbs = [{ text: 'Overview' }];
					args = ['render:newsletterListsOverview'];
					break;
			}

			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});

			this.options.dispatcher
				.trigger.apply(this.options.dispatcher, args);
		},
		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:newslettersSideNav', bool);
			this.resizeContent();
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');

			this.resetChildren();
		}
	}));
	/*----------------*/

	/* This initializes the main Newsletters view and the Create a Newsletter List view */
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Views.NewslettersContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.NewslettersDashboard(this.options),
				new LA.Views.NewsletterListCreate(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/

	/* Current Lists view for Newsletters */
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Views.NewsletterListItems = Backbone.View.extend($.extend({}, {
		events: {
			'click .lists-status a.btn': 'toggleButtonState'
		},
		initialize: function (options) {
			this.options = options;
			this.template = options.template;
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter({ isSearch: false, page: 1, size: 50, status: 1, starFilterType: LA.ApplicationState.Filters.defaults.DefaultNewsletterListUserStarFilter }),
				Payload: new LA.Models.Payload()
			});
	
			_.bindAll(this, "render",
				"renderControls",
				"toggleButtonState",
				"updateHash",
				"resizeList",
				"scrollList",
				"keyUp",
				"setFilter",
				"fetchItems",
				"displayItems",
				"deactivateList",
				"reactivateList"
			);

			this.options.dispatcher
				.on('render:newsletterListItems', this.render)
				.on('deactivate:list', this.deactivateList)
				.on('reactivate:list', this.reactivateList);

			this.on('fetch:items', this.fetchItems);
			this.models.Filter
				.on('change', this.fetchItems);

			this.models.Payload
				.on('change', this.displayItems);
		},
		render: function () {
			var self = this,
				resizeHandler,
				scrollHandler,
				keyUpHandler;

			// Do Get just after default filter values loaded.
			LA.ApplicationState.Filters.getProperties('DefaultNewsletterListUserStarFilter').done(function (properties) {
				LA.ajax({
					url: LA.Path + '/NewsletterLists/CurrentLists',
					type: 'GET',
					data: {}
				}, function (resp) {
					self.$el.empty().html(resp);
					self.models.Filter.clear({ silent: true });
					self.models.Filter.set({ page: 1, size: 50, status: 1, starFilterType: properties.DefaultNewsletterListUserStarFilter });
					self.renderControls();
					self.resizeList();
					self.$starFilter.find('[data-starvalue="' + properties.DefaultNewsletterListUserStarFilter + '"]').addClass('active').siblings().removeClass('active');
				}, function () {
					resizeHandler = _.debounce(function () { self.resizeList(); }, 100);
					scrollHandler = _.debounce(function (e) { self.scrollList(e); }, 300);
					keyUpHandler = _.debounce(function (e) { self.keyUp(e); }, 300);

					$(window).on('resize.items', resizeHandler);

					self.$('#newsletterLists-listing')
						.on('scroll.items', scrollHandler);

					self.$('#search').on('keyup.newsletterList', keyUpHandler);
				});
			});


		},
		renderControls: function () {
			this.$statusGrp = this.$('#status #statusFilter');
			this.$starFilter = this.$('#status #userStarFilter');
		},
		toggleButtonState: function (e) {
			var $el = $(e.target);
			if ($el.is('i')) {
				$el = $el.parent();
			}
			if ($el.hasClass('btn') && $el.hasClass('disabled')) {
				e.preventDefault();
				return;
			} else {
				if ($el.hasClass('btn') && !$el.hasClass('active')) {
					$el.siblings().removeClass('active');
					$el.addClass('active');
				}
				this.updateHash();
			}
		},
		updateHash: function () {
			var value = this.$statusGrp.find('.active').attr('data-val');
			var starFilterValue = this.$starFilter.find('.active').attr('data-starvalue');

			if (value < 1 || value > 3) {
				value = 1;
			}

			this.setFilter({ page: 1, status: value, starFilterType: starFilterValue });
		},
		resizeList: function () {
			this.$('#newsletterLists-listing')
				.css('height', this.$el.height() - this.$('.row-fluid.heading').outerHeight(true));
		},
		scrollList: function (e) {
			commonScrollList(this, e, 'page', 'fetch:items');
		},
		keyUp: function () {
			this.setFilter({ isSearch: true, page: 1, filterBy: this.$('#search').val() });
		},
		setFilter: function (data, options) {
			//setting silent = false will raise a change event for the Filter which then is bound to fetchItems
			this.models.Filter.set(data, $.extend({}, { silent: false }, options));

			this.$statusGrp.find('a[data-val="' + this.models.Filter.get('status') + '"]').addClass('active');
			this.$starFilter.find('a[data-starvalue="' + this.models.Filter.get('starFilterType') + '"]').addClass('active');
		},
		fetchItems: function () {
			var self = this;

			// Do Get
			LA.ajax({ url: LA.Path + '/NewsletterLists/GetNewsletterLists', type: 'GET', data: this.models.Filter.toJSON(), dataType: 'json' }, function (resp) {
				// We always want to trigger the change event, so clear the model
				// silently then set to force change.
				self.models.Payload.clear({ silent: true });
				self.models.Payload.set(resp);
			});
		},
		displayItems: function () {
			var page = this.models.Filter.get('page'),
				doRender = page === 1,
				payload = this.models.Payload.toJSON(),
				filter = this.models.Filter.toJSON(),
				content = this.template({
					data: payload.Data, filters: {
						isSearch: filter.isSearch
					}
				});

			if (doRender) {
				this.$('#newsletterLists-listing').empty().html(content);
			} else {
				this.$('#newsletterLists-listing').append(content);
			}

			this.models.Filter.set({ 'page': ++page }, { silent: true });
		},
		deactivateList: function (id) {
			var self = this;

			var doDeactivate = function () {
				$.post(LA.Path + '/NewsletterLists/Deactivate/' + id, function (data) {
					var message = !data.success ? data.error : null;
					if (data.success) {
						self.models.Filter.set({ page: 1 });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'List Deactivation',
							width: 350,
							height: 150,
							zIndex: 100010,
							backdrop: 'static',
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			$('<div>' + Res.Strings.Newsletters.confirmDeactivate + '</div>').modal({
				title: 'Confirm Deactivate',
				width: 350,
				height: 175,
				zIndex: 100010,
				backdrop: 'static',
				show: true,
				buttons: [
					{
						text: 'Yes',
						click: function () {
							doDeactivate();
							this.hide();
						}
					},
					{
						text: 'Cancel'
					}
				]
			});
		},
		reactivateList: function (id) {
			var self = this;

			var doReactivate = function () {
				$.post(LA.Path + '/NewsletterLists/Reactivate/' + id, function (data) {
					var message = !data.success ? data.error : null;
					if (data.success) {
						self.models.Filter.set({ page: 1 });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'List Reactivation',
							width: 350,
							height: 150,
							zIndex: 100010,
							backdrop: 'static',
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			$('<div>' + Res.Strings.Newsletters.confirmReactivate + '</div>').modal({
				title: 'Confirm Reactivate',
				width: 350,
				height: 175,
				zIndex: 100010,
				backdrop: 'static',
				show: true,
				buttons: [
					{
						text: 'Yes',
						click: function () {
							doReactivate();
							this.hide();
						}
					},
					{
						text: 'Cancel'
					}
				]
			});
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.items');
			this.$('#newsletterLists-listing').off('scroll.items');
			this.$('#search').off('keyup.newsletterList');
		}
	}));
	/*----------------*/

	/* Overview view for the main Newsletters section (this does not include the metrics partial) */
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Views.NewsletterListsOverview = Backbone.View.extend($.extend({}, {
		events: {
			'click .issues-status #deliveredStatus a.btn': 'toggleButtonState',
			'filterChanged .issues-status #userStarFilter': 'filterChanged'
		},
		initialize: function (options) {
			this.options = options;
			this.haveWeStoppedFetchingMoreNewsletterIssues = true;
			this.pageSize = 75;
			this.template = options.template;
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter({ status: 1, page: 1, pageSize: this.pageSize, update: false }), //status = 1 (draft), 2 (scheduled), 3 (delivered)
				Payload: new LA.Models.Payload()
			});

			_.bindAll(this, 'render',
				'scroll',
				'resizeList',
				'renderControls',
				'toggleButtonState',
				'updateHash',
				'setFilter',
				'filterChanged',
				'fetchItems',
				'copyIssue',
				'deleteIssue',
				'displayItems');

			this.options.dispatcher
				.on('render:newsletterListsOverview', this.render)
				.on('delete:overviewIssue', this.deleteIssue);

			this.on('fetch:items', this.fetchItems);

			this.models.Filter
				.on('change', this.fetchItems);

			this.models.Payload
				.on('change', this.displayItems);
		},
		render: function () {
			var self = this;
			var resizeHandler;
			var scrollHandler;
			LA.ApplicationState.Filters.getProperties('DefaultNewsletterListUserStarFilter').done(function (properties) {
				// Do Get
				LA.ajax({
					url: LA.Path + '/NewsletterLists/Overview',
					type: 'GET',
					data: {}
				}, function (resp) {
					self.$el.empty().html(resp);
					self.renderControls();
					self.models.Filter.clear({ silent: true });
					self.setFilter({ status: 1, starFilterType: properties.DefaultNewsletterListUserStarFilter });
					$('.newsletters-overview [data-userstarfilter] a[data-starvalue="' + properties.DefaultNewsletterListUserStarFilter + '"]').addClass('active').siblings().removeClass('active');
				}, function () {
					resizeHandler = _.debounce(function () { self.resizeList(); }, 100);
					scrollHandler = _.debounce(function (e) { self.scroll(e); }, 100);
					
					$(window).on('resize.items', resizeHandler);
					self.$('#newsletterLists-overview').on('scroll.newsletterlists', scrollHandler);

					self.$('#newsletterLists-overview').on('click', 'a.issue-preview', function () {
						var a = $(this),
							url = a.attr('data-target');

						$('<div><iframe id="previewIssue" src="' + url + '" style="width:900px;height:458px;"></iframe></div>').modal({
							title: 'Issue Preview',
							width: 940,
							height: 580,
							zIndex: 100010,
							onLoad: function (modal) {
								modal.find('iframe').on('load', function () {
									var contents = $(this).contents();
									contents.find('a').attr('target', '_blank');

								});
							},
							buttons: [
								{
									text: 'Print',
									click: function () {
										var $iframe = $('#previewIssue');

										if ($iframe.length > 0) {
											var iw = $iframe[0].contentWindow || $iframe[0];
											iw.focus();
											iw.print();
										}

										this.hide();
									}
								},
								{
									text: 'Close'
								}
							],
							show: true
						});

					});
					self.$('#newsletterLists-overview').on('click', 'a.issue-copy', function () {
						var a = $(this),
							issueName = a.attr('data-issueName'),
							issueId = a.attr('data-issueid');

						self.copyIssue(issueId, issueName);
					});
				});
			});
		},
		scroll: function (e) {
			var $el = $(e.currentTarget),
				scrollHeight = e.currentTarget.scrollHeight,
				scrollTop = $el.scrollTop(),
				outerHeight = $el.outerHeight();

			var newsletterListHeight = $el.find('.newsletterList').outerHeight(true);

			var isAtBottomOfScroll = scrollHeight - scrollTop < outerHeight + newsletterListHeight;
			var shouldFetchMoreNewsletterIssues = isAtBottomOfScroll && this.haveWeStoppedFetchingMoreNewsletterIssues;
			if (shouldFetchMoreNewsletterIssues) {
				this.haveWeStoppedFetchingMoreNewsletterIssues = false;
				this.models.Filter.set('page', this.models.Filter.get("page") + 1);
				this.trigger('fetch:items');
			}
		},
		resizeList: function () {
			var self = this;
			self.$("#newsletterLists-overview").css({
				height: $("#sidebar-content").height() - self.$(".heading").outerHeight(true)
			});
		},
		renderControls: function () {
			this.$statusGroup = this.$('#deliveredStatus .btn-group');
			$("#sidebar-content").css('overflow', 'hidden');
			this.resizeList();
		},
		toggleButtonState: function (e) {
			var $el = $(e.target);
			if ($el.is('i')) {
				$el = $el.parent();
			}
			if ($el.hasClass('btn') && $el.hasClass('disabled')) {
				e.preventDefault();
				return;
			} else {
				if ($el.hasClass('btn') && !$el.hasClass('active')) {
					$el.siblings().removeClass('active');
					$el.addClass('active');
				}
				this.updateHash();
			}
		},
		updateHash: function () {
			var value = this.$statusGroup.find('.active').attr('data-val');

			if (value < 1 || value > 4) {
				value = 1;
			}

			this.setFilter({ status: value, page: 1 });
		},
		setFilter: function (data, options) {
			var self = this;
			if (!data.page) {
				data.page = 1;
			}
			data.pageSize = this.pageSize;
			if (data.page === 1) {
				self.preventFetch = false;
			}
			//setting silent = false will raise a change event for the Filter which then is bound to fetchItems
			self.models.Filter.set(data, $.extend({}, { silent: false }, options));

			self.$statusGroup.find('a[data-val="' + self.models.Filter.get('status') + '"]').addClass('active');
		},
		filterChanged: function (evt) {
			var filterValues = {
				starFilterType: evt.filterValue,
				page: 1
			};

			this.setFilter(filterValues);
		},
		fetchItems: function () {
			var self = this;
			// Do Get
			if (!self.preventFetch || self.models.Filter.attributes.update) {
				LA.ajax({ url: LA.Path + '/NewsletterIssues/GetCurrentNewsletterIssues', type: 'GET', data: this.models.Filter.toJSON(), dataType: 'json' }, function (resp) {
					// We always want to trigger the change event, so clear the model
					// silently then set to force change.
					
					self.models.Payload.clear({ silent: true });
					self.models.Payload.set(resp);
					if (resp.Data.length < self.pageSize) {
						self.preventFetch = true;
					}
					self.haveWeStoppedFetchingMoreNewsletterIssues = true;
				});
			}

		},
		copyIssue: function (issueId) {
			var self = this;
			var afterCopy = function (modal, data) {
				modal.hide();
				self.$statusGroup.find('a[data-val="' + self.models.Filter.get('status') + '"]').removeClass('active');
				self.fadeDocId = data.id;
				self.setFilter({ status: 1, update: true });
			};

			copyNewsletterIssue(issueId, this, afterCopy);
		},
		deleteIssue: function (id) {
			var self = this;

			var doDelete = function () {
				$.post(LA.Path + '/NewsletterIssues/Delete/' + id, function (data) {
					var message = !data.success ? data.message : null;
					if (data.success) {
						self.models.Filter.set({ update: true });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'Issue Delete',
							width: 350,
							height: 150,
							zIndex: 100010,
							backdrop: 'static',
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			$('<div>' + Res.Strings.Newsletters.confirmDeleteIssue + '</div>').modal({
				title: 'Confirm Delete',
				width: 570,
				height: 'auto',
				zIndex: 100010,
				backdrop: 'static',
				show: true,
				buttons: [
					{
						text: 'Delete',
						'class': 'btn-danger',
						click: function () {
							doDelete();
							this.hide();
						}
					},
					{
						text: 'Cancel'
					}
				]
			});
		},
		displayItems: function () {
			var payload = this.models.Payload.toJSON(),
				filter = this.models.Filter.toJSON(),
				content = this.template({
					data: payload.Data,
					filters: {
						status: filter.status,
						page: filter.page
					}
				});
			var contentArea = this.$('#newsletterLists-overview');
			if (this.models.Filter.get('page') === 1) {
				contentArea.empty().html(content);
			} else {
				contentArea.append(content);
			}

			this.models.Filter.attributes.update = false;

			if (this.fadeDocId) {
				var fadeDoc = $('.newsletterList[data-doc-id="' + this.fadeDocId + '"]');
				flashBackground(fadeDoc, 'background-whitesmoke');
			}

			this.fadeDocId = null;
		},
		reset: function () {
		}
	}));
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.AdvanceListOverview = Backbone.View.extend($.extend({}, {
		events: {
			'update .advance-list-overview .filter-row select': 'updateFilters',
			'liszt:ready .advance-list-overview .filter-row select': 'addCustomLabel', //Add the custom label to the chosen control when the list is ready
			'uploadSuccess #uploadForm': 'updateFiltersFromUpload'
		},
		initialize: function (options) {
			this.options = options;
			this.template = options.template;
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter({}),
				Payload: new LA.Models.Payload(),
				AdvanceList: new LA.Models.AdvanceList()
			});

			_.bindAll(this, 'render',
				'renderUpload',
				'resizeList',
				'addCustomLabel',
				'isOtsConfigured',
				'setIndexFilterValues',
				'updateFiltersFromUpload',
				'updateFilters',
				'setFilter',
				'fetchAdvanceList',
				'fetchLocalHoldings',
				'displayItems');

			this.options.dispatcher.on('render:advanceListOverview', this.render);
			this.options.dispatcher.on('render:advanceListUpload', this.renderUpload);
			this.options.dispatcher.on('update:advanceListFilters', this.updateFilters);
			this.options.dispatcher.on('refresh:displayItems', this.displayItems);
			this.on('fetch:advanceList', this.fetchAdvanceList);
			this.models.Filter.on('change', this.displayItems);
			this.models.Payload.on('change', this.displayItems);

		},
		render: function (year, month) {
			var self = this;
			LA.ajax({
				url: LA.Path + '/AdvanceList/Index',
				type: 'GET',
				data: {}
			}, function (resp) {
				self.$el.empty().html(resp);
				if (year && month) {
					self.$('#advanceListMonth').val(month);
					self.$('#advanceListYear').val(year);
				}
				self.recordSearchResultTemplates = {};
				// Load templates for availability check (look in AdvanceList _Index.cshtml)
				self.$el.find('.availabilitySearchResultTemplate').each(function (index, templateElement) {
					var $templateElement = $(templateElement);
					var templateName = $templateElement.attr('id').split('-')[1];
					self.recordSearchResultTemplates[templateName] =
						_.template($templateElement.html()
							.replace(/&gt;/g, '>')
							.replace(/&lt;/g, '<'));
				});

				// bind retry handler for items that fail to check
				$('#advanceListWrapper').on('click', '.holdings.failedRetry', function () {
					var advanceListRecord = $(this).closest('.advanceListRecord');
					self.fetchLocalHoldings(advanceListRecord);
				});

				self.otsConfigurationId = self.$el.find('#IsOnTheShelfConfigured').val().toLowerCase() === "true";
				self.updateFilters();
				self.setIndexFilterValues();
				self.displayItems();
				self.resizeList();
			}
			);
		},
		renderUpload: function () {
			var self = this;
			LA.ajax({
				url: LA.Path + '/AdvanceList/Upload',
				type: 'GET',
				data: { orgID: LA.orgId }
			}, function (resp) {
				self.$el.empty().html(resp);
			});

		},
		resizeList: function () {
			var self = this;
			self.$("#advanceList").css({
				height: $("#sidebar-content").height() - self.$(".heading").outerHeight(true)
			});
		},
		addCustomLabel: function (e) {
			prependLabelToChosenControl(e);
		},
		isOtsConfigured: function () {
			var self = this;
			return !!self.otsConfigurationId;
		},
		setIndexFilterValues: function () {
			var filterValues = {
				Month: null,
				Year: null
			};

			if (this.models.AdvanceList.get('Month') !== null && this.models.AdvanceList.get('Year') !== null) {
				filterValues.Month = this.models.AdvanceList.get('Month');
				filterValues.Year = this.models.AdvanceList.get('Year');

				this.$('#advanceListMonth').val(filterValues.Month);
				this.$('#advanceListYear').val(filterValues.Year);
				this.setFilter(filterValues, { silent: true });
			}

			filterValues.Month = null;
			filterValues.Year = null;
			// clear the advance list values so we do not force filter
			// the above stuff should only happen if we successfully upload an advance list
			this.models.AdvanceList.set(filterValues, { silent: true });
		},
		updateFiltersFromUpload: function () {
			var dateString = this.$("#ListUseDate option:selected").val();
			var date = new Date(dateString);
			var filterValues = {
				Month: date.getUTCMonth() + 1,
				Year: date.getUTCFullYear()
			};
			this.models.AdvanceList.set(filterValues, { silent: true });
			//this.setFilter(filterValues, { silent: true });

		},
		updateFilters: function (e) {
			//Clear status message
			$('.filter-row .statusMessage').fadeOut('slow');

			var newsletterList = this.$('#NewsletterListNames').val();
			var month = this.$('#advanceListMonth').val();
			var year = this.$('#advanceListYear').val();

			var filterValues = {
				NewsletterListId: (_.isUndefined(newsletterList) ? null : newsletterList),
				Month: (_.isUndefined(month) ? null : month),
				Year: (_.isUndefined(year) ? null : year),
				pageNum: 1
			};

			this.setFilter(filterValues);

			if (e !== undefined) {
				prependLabelToChosenControl(e);
			}
		},
		setFilter: function (data, options) {
			this.models.Filter.set(data, $.extend({}, { silent: false }, options));
			//ensure that the URL is kept up-to-date
			LA.AppRouter.navigate("#!/newsletters/advance-list/" + data.Year + "-" + data.Month, { trigger: false, replace: false });
		},
		fetchAdvanceList: function () { },
		fetchLocalHoldings: function (advanceListRecords) {
			var self = this;
			// get isbns
			var records = {};
			var isbns = [];

			// stick all isbns into array
			// put all elements that have the isbn into an array
			// for quicker lookup
			advanceListRecords.each(function (index, element) {
				var elm = $(element);
				var isbn = parseInt(elm.attr('data-isbn'), 10);
				if (_.isUndefined(records[isbn])) {
					records[isbn] = [];
				}
				records[isbn].push(elm);
				isbns.push(isbn);
				elm.find('.holdings').replaceWith(self.recordSearchResultTemplates.looking());
			});

			// send request for isbns
			// if catalog configured, we should hit the
			if (isbns.length > 0) {

				// if ots, batch by five and submit to ots module
				if (self.isOtsConfigured()) {
					var getAvailabilityForBatch = function (isbnBatch) {
						jQuery.ajax({
							type: 'POST',
							url: LA.Path + '/OnTheShelf/NehAvailability',
							data: {
								isbns: isbnBatch
							},
							traditional: true
						})
							.done(function (resultRecords) {
								resultRecords.forEach(function (record) {
									// get the element that corresponds to the id
									var advanceListRecordsToUpdate = records[record.key];

									_.each(advanceListRecordsToUpdate, function (advanceListRecord) {
										var holdingsElement = $(advanceListRecord).find('.holdings');
										if (record.result_status !== 'OK') {
											holdingsElement.replaceWith(self.recordSearchResultTemplates.failedRetry({ data: { isbn: record.key } }));
										} else if (record.items.length === 0) {
											holdingsElement.replaceWith(self.recordSearchResultTemplates.none());
										} else {
											// get the total items available and total copies in the system
											// pass that information along with all the format details to the template method
											var total = _.pluck(record.items, 'total').reduce(function (a, b) { return a + b; }, 0);
											var available = _.pluck(record.items, 'available').reduce(function (a, b) { return a + b; }, 0);
											holdingsElement.replaceWith(self.recordSearchResultTemplates.available({ data: { TotalCopies: total, AvailableCopies: available, items: record.items } }));
										}
									});

								});
							})
							.fail(function () {
								_.each(isbnBatch, function (isbn) {
									// find all the elements that have the ISBN
									var advanceListRecordsToUpdate = records[isbn];

									//update them to a failed state
									_.each(advanceListRecordsToUpdate, function (advanceListRecord) {
										$(advanceListRecord).find('.holdings').replaceWith(self.recordSearchResultTemplates.failedRetry());
									});
								});
							});
					}

					//// batch the isbns found into bunches of 10
					var batchedIsbns = [];
					_.each(isbns, function (isbn, index) {
						var groupingIndex = Math.floor(index / 10);
						if (batchedIsbns[groupingIndex] == undefined) {
							batchedIsbns[groupingIndex] = [];
						}
						batchedIsbns[groupingIndex].push(isbn);
					});

					for (var batchIndex = 0; batchIndex < batchedIsbns.length; batchIndex++) {
						getAvailabilityForBatch(batchedIsbns[batchIndex]);
					}

				} else {
					//else do standard lookup
					$.ajax({
						url: LA.Path + '/AdvanceList/CheckLocalHoldings',
						type: "POST",
						dataType: "json",
						data: { isbns: isbns },
						traditional: true,
						success: function (response) {
							if (response.success) {
								var index = 0;
								if (response.localHoldingsConfigured) {

									for (index = 0; index < response.isbns.length; index++) {
										_.each(records[response.isbns[index]], function (element) {
											element.find('.holdings').replaceWith(self.recordSearchResultTemplates.available());
										});
									}
									var isbnsNotFound = _.difference(isbns, response.isbns);
									for (index = 0; index < isbnsNotFound.length; index++) {
										_.each(records[isbnsNotFound[index]], function (element) {
											element.find('.holdings').replaceWith(self.recordSearchResultTemplates.none());
										});
									}
								} else {

									for (index = 0; index < isbns.length; index++) {
										_.each(records[isbns[index]], function (element) {
											element.find('.holdings').replaceWith(self.recordSearchResultTemplates.failed());
										});
									}
								}
							}
						},
						error: function () {
							var index = 0;
							for (index = 0; index < isbns.length; index++) {
								_.each(records[isbns[index]], function (element) {
									element.find('.holdings').replaceWith(self.recordSearchResultTemplates.failed());
								});
							}
						}
					});
				}
			}
		},
		displayItems: function () {
			var self = this;
			var filters = this.models.Filter;
			LA.ajax({
				url: LA.Path + '/AdvanceList/DisplayAdvanceListRecords',
				type: 'GET',
				data: filters.toJSON()
			}, function (resp) {
				var advanceList = self.$el.find('#advanceList');
				advanceList.empty().html(resp);

				var numberOfRecords = $('.advanceListRecord').length;
				if ($('input[name="HideExportButton"]').val() === "true") {
					$('a.exportBtn').addClass('disabled');
				}
				else { $('a.exportBtn').removeClass('disabled'); }

				$('#cart-total-count').text(numberOfRecords);

				// go get the holdings information for all of the advance list records
				// if there are not any, this will do nothing
				self.fetchLocalHoldings($(".advanceListRecord", advanceList));
			});
		}
	}
	));

	/* View for Create a New Newsletter List. It does not include the sidebar navigation. */
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Views.NewsletterListCreate = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:newsletterListCreate', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/NewsletterLists/Create', type: 'GET' }, function (resp) {
				self.options.dispatcher
					.trigger('set:content', resp, 'newsletterList-create-rendered');
				self.$('[data-chosen=True]').chosen().removeAttr('data-chosen');
				$.validator.unobtrusive.parse(self.$('form'));
			});
		}
	});
	/*----------------*/

	/* Issues view for a single Newsletter List */
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Views.NewsletterIssueListView = Backbone.View.extend($.extend({
		initialize: function (options) {
			this.options = options;
			// get the templates for newsletter issues
			this.templates = LA.filterTemplates(/^NewsletterIssues\//);
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter(),
				Payload: new LA.Models.Payload()

			});

			_.bindAll(this, 'render',
				'keyUp',
				'setFilter',
				'fetchItems',
				'displayItems',
				'resizeList',
				'scrollList',
				'displayMetricDetails',
				'displaySendDetails',
				'copyIssue',
				'deleteIssue',
				'reset');

			this.options.dispatcher.on('render:newsletterIssueListView', this.render)
				.on('delete:issue', this.deleteIssue);

			this.on('fetch:items', this.fetchItems);
			this.models.Filter.on('change', this.fetchItems);
			this.models.Payload.on('change', this.displayItems);

		},
		render: function (url) {
			// handles rendering of list view
			// go get the view
			// load it into the content area
			// set up scroll stuff
			var self = this,
				resizeHandler,
				scrollHandler,
				keyupHandler;

			// Do Get
			LA.ajax({
				url: url,
				type: 'GET'
			}, function (resp) {
				// put our list container in the main content area
				self.$el.empty().html(resp);
				// clear the filter data we stored for our list (search terms)
				// set silent to true so we do not trigger a change even on our model
				// that would result in going to fetch items with an empty model... BAD!!
				self.models.Filter.clear({ silent: true });

				// set our default page information
				self.models.Filter.set({ isSearch: false, page: 1, size: 50 });

				self.resizeList();
			}, function () {
				resizeHandler = _.debounce(function () { self.resizeList(); }, 100);
				scrollHandler = _.debounce(function (e) { self.scrollList(e); }, 300);
				keyupHandler = _.debounce(function () { self.keyUp(); }, 300);

				// attach resize and scroll handlers
				$(window).on('resize.items', resizeHandler);
				self.$('#newsletterIssues').on('scroll.items', scrollHandler);
				self.$('#search').on('keyup.search', keyupHandler);
				self.$('#newsletterIssues').on('click', 'a.issue-preview', function () {
					var a = $(this),
						url = a.attr('data-target');

					$('<div><iframe id="previewIssue" src="' + url + '" style="width:900px;height:458px;"></iframe></div>').modal({
						title: 'Issue Preview',
						width: 940,
						height: 580,
						zIndex: 100010,
						buttons: [
							{
								text: 'Print',
								click: function () {
									var $iframe = $('#previewIssue');

									if ($iframe.length > 0) {
										var iw = $iframe[0].contentWindow || $iframe[0];
										iw.focus();
										iw.print();
									}

									this.hide();
								}
							},
							{
								text: 'Close'
							}
						],
						show: true
					});

				});
				self.$('#newsletterIssues').on('click', 'a.issue-statistics-link', function () {
					var a = $(this),
						targetElementId = '#' + a.attr('data-elementid');
					jQuery(targetElementId).slideToggle();
				});

				self.$('#newsletterIssues').on('click', '.issue-details-link', function () {
					var a = $(this),
						issueId = a.attr('data-issueid'),
						timezoneId = a.attr('data-timezoneid'),
						actionId = a.attr('data-actionid');

					self.displayMetricDetails(issueId, timezoneId, actionId);
				});

				self.$('#newsletterIssues').on('click', '.issue-send-details-link', function () {
					var a = $(this),
						issueName = a.attr('data-issueName'),
						issueId = a.attr('data-issueid');

					self.displaySendDetails(issueId, issueName);
				});
				self.$('#newsletterIssues').on('click', 'a.issue-copy', function () {
					var a = $(this),
						issueName = a.attr('data-issueName'),
						issueId = a.attr('data-issueid');

					self.copyIssue(issueId, issueName);
				});
			});
		},
		keyUp: function () {
			this.setFilter({ isSearch: true, page: 1, filterBy: this.$('#search').val() });
		},
		setFilter: function (data, options) {
			this.models.Filter.set(data, $.extend({}, { silent: false }, options));
		},

		fetchItems: function () {
			// go get the items needed for display
			var self = this;

			// Do Get
			LA.ajax({ url: LA.Path + '/NewsletterIssues/GetListForGrid/' + self.models.NewsletterList.get('id'), type: 'GET', data: this.models.Filter.toJSON(), dataType: 'json' }, function (resp) {
				// We always want to trigger the change event, so clear the model
				// silently then set to force change.
				self.models.Payload.clear({ silent: true });
				self.models.Payload.set(resp);
			});
		},
		displayItems: function () {
			// display those items from the request
			var page = this.models.Filter.get('page'),
				doRender = page === 1,
				payload = this.models.Payload.toJSON(),
				content = this.templates.ListItem({
					data: payload.Data
				});

			if (doRender) {
				this.$('#newsletterIssues').empty().html(content);
			} else {
				this.$('#newsletterIssues').append(content);
			}

			this.models.Filter.set({ 'page': ++page }, { silent: true });
		},
		resizeList: function () {
			// resize the newsletter issue list
			this.$('#newsletterIssues')
				.css('height', this.$el.height() - this.$('.row-fluid.heading').outerHeight(true));
		},
		scrollList: function (e) {
			commonScrollList(this, e, 'page', 'fetch:items');
		},
		displayMetricDetails: function (issueId, timezoneId, actionId) {
			var $m = $('<div />');

			var options = {
				width: 940,
				height: 580,
				zIndex: 100010,
				buttons: [{ text: 'Close' }],
				show: true
			};

			var endpoint = LA.WebRoot + LA.OrganizationId + '/Metrics/ViewNewsletterIssueActions';
			var queryString = '?id=' + issueId + '&timeZoneId=' + encodeURIComponent(timezoneId) +
				'&actionId=' + actionId;

			$.ajax(endpoint + queryString)
				.done(function (content) {
					$m.html(content);

					var $content = $(content);
					$content.filter('script[type="text/javascript"]').each(function () {
						$.globalEval($(this).text());
					});

					var config = $.extend({}, options);
					switch (actionId) {
						case "2":
							config.title = "Newsletter Issue Clicks";
							config.onLoad = buildClickGrid;
							break;
						case "3":
							config.title = "Newsletter Issue Bounces";
							config.onLoad = buildBounceGrid;
							break;
						case "4":
							config.title = "Newsletter Issue Unsubscribes";
							config.onLoad = buildUnsubscribeGrid;
							break;
						case "5":
							config.title = "Newsletter Issue Views";
							config.onLoad = buildViewsGrid;
							break;
						case "6":
							config.title = "Newsletter Issue Views";
							config.onLoad = buildViewsGrid;
							break;
						case "7":
							config.title = "Newsletter Individual Link Clicks";
							config.onLoad = buildIndividualLinkClicksGrid;
							break;
						default:
							config.title = "Newsletter Unique Opens";
							config.onLoad = buildOpenGrid;
							break;
					}

					$m.modal(config);
				});
		},
		displaySendDetails: function (issueId, issueName) {
			var $s = $('<div />');

			var opts = {
				width: 570,
				height: 400,
				zIndex: 100010,
				buttons: [{ text: 'Close' }],
				show: true
			};

			$.ajax(LA.WebRoot + LA.OrganizationId + '/NewsletterIssues/ViewNewsletterIssueSendDetails?id=' + issueId)
				.done(function (content) {
					$s.html(content);

					var $content = $(content);
					$content.filter('script[type="text/javascript"]').each(function () {
						$.globalEval($(this).text());
					});

					var config = $.extend({}, opts);
					config.title = issueName + " Send Details";
					config.onLoad = buildSendGrid;

					$s.modal(config);
				});
		},
		copyIssue: function (issueId) {
			var self = this;
			var afterCopy = function (modal) {
				modal.hide();
				self.models.Filter.set({ page: 1 });
			};

			copyNewsletterIssue(issueId, this, afterCopy);
		},
		deleteIssue: function (id) {
			var self = this;

			var doDelete = function () {
				$.post(LA.Path + '/NewsletterIssues/Delete/' + id, function (data) {
					var message = !data.success ? data.error : null;
					if (data.success) {
						self.models.Filter.set({ page: 1 });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'Issue Delete',
							width: 350,
							height: 150,
							zIndex: 100010,
							backdrop: 'static',
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			$('<div>' + Res.Strings.Newsletters.confirmDeleteIssue + '</div>').modal({
				title: 'Confirm Delete',
				width: 570,
				height: 'auto',
				zIndex: 100010,
				backdrop: 'static',
				show: true,
				buttons: [
					{
						text: 'Delete',
						'class': 'btn-danger',
						click: function () {
							doDelete();
							this.hide();
						}
					},
					{
						text: 'Cancel'
					}
				]
			});
		},
		reset: function () {
			$(window).off('resize.items');
			self.$('#newsletterIssues').off('scroll.items');
			self.$('#search').off('keyup.search');
			$('#newsletterIssues').off('click', 'a.issue-preview');
			$('#newsletterIssues').off('click', 'a.issue-statistics-link');
			$('#newsletterIssues').off('click', '.issue-details-link');
		}
	}));
	/*----------------*/

	/* Dashboard view for a single Newsletter List */
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.NewsletterListDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			// Get newsletter list templates
			this.templates = LA.filterTemplates(/^NewsletterLists\/Dashboard/);
			this.models = {
				NewsletterList: new LA.Models.NewsletterList()
			};


			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:newsletterListSideNav', setEvent: 'set:newsletterListSideNavModel', showEvent: 'show:newsletterListSideNav' })),
				new LA.Views.NewsletterIssueListView($.extend({}, this.options, { models: this.models })),
				new LA.Views.NewsletterListAdmin($.extend({}, this.options))
			];

			_.bindAll(this, 'render',
				'renderCrumbsAndChild',
				'getNewsletterListDetails',
				'renderUrlContent',
				'reset',
				'setNewsletterListContent',
				'resize',
				'setContent');

			this.options.dispatcher
				.on('render:newsletterListDashboard', this.render)
				.on('render:newsletterListCrumbsAndChild', this.renderCrumbsAndChild)
				.on('resize:newsletterListLayout', this.resize)
				.on('set:newsletterListContent', this.setContent)
				.on('render:urlcontent', this.renderUrlContent)
				.on('get:newsletterListDetails', this.getNewsletterListDetails);
		},
		render: function (action, id) {
			var self = this,
				resizeHandler;

			// set the content
			this.options.dispatcher
				.trigger('set:content', '<div id="deactivated-warning" class="notice" style="display:none"></div><div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'newsletterList-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			// trigger event for setting side nave view model
			// this is where we get to pass additional information that can be used when processing the side bar navigation template
			// in our case, id is important so our links work properly
			this.options.dispatcher
				.trigger('set:newsletterListSideNavModel', { action: action, id: id });

			this.resizeContent();
			resizeHandler = _.debounce(function () { self.resizeContent(); }, 100);
			$(window).on('resize.sidebarContent', resizeHandler);
		},
		getNewsletterListDetails: function (action, id, issueId, goBackPage, postId) {

			var self = this;
			// store the details of the newsletter list we are working with
			// to provide context for the list and issue pages.

			// Look at the model defined in the top of the file for the url for getting details
			// the fetch method of backbone automatically appends the id of the model to the url path, makes the request, and updates the members on the model with the values returned
			// in the json response

			// the reason we always fetch our details, is because details may have been updated at another time and our model may be stale since the model is only created fresh one time (during view initialization)
			// this method will should also be called upon saving data from administration of the newsletter list (in case the name changed so our crumbs display correctly)
			// there may be a better way to get the details without having to make this second request
			this.models.NewsletterList.set({ id: id, silent: true });
			this.models.NewsletterList.fetch({ success: function () { self.renderCrumbsAndChild(action, id, issueId, goBackPage, postId); } });

		},
		renderCrumbsAndChild: function (action, id, issueId, goBackPage, postId) {
			var self = this;
			var crumbs;
			var url = LA.Path;
			var args;
			var view;
			var viewOptions;

			this.options.dispatcher
				.trigger('add:crumb', { text: 'Newsletters', fragment: '#!/newsletters' }, { isRoot: true })
				.trigger('add:crumb', { text: this.models.NewsletterList.get('name'), fragment: '#!/newsletters/__ID__/overview'.replace('__ID__', id) });

			if (this.models.NewsletterList.get('isActive') === false) {
				$('#deactivated-warning').css('display', 'block').html(Res.Strings.Newsletters.warningDeactivated);
				$('#content').css('overflow-y', 'hidden');
			}
			else {
				$('#deactivated-warning').css('display', 'none');
				$('#content').css('overflow-y', 'auto');
			}

			// based on action we will determine what view should be displayed
			// this will build the arguments used to raise an event for which view to display
			// most views will just go get content and load it into the content pane, so an event that this view
			// is listening for will be raised 'render:urlcontent'.  For other cases, the view that is designed specifically
			// for that page will handle the event (only the issue list will do this right now... maybe the overview)
			switch (action) {
				case 'issues':
					crumbs = [{ text: 'Current Issues' }];
					args = ['render:newsletterIssueListView', url + '/NewsletterIssues/Index/' + id, id];
					break;
				case 'administration':
					crumbs = [{ text: 'Administration' }];
					args = ['render:newsletterListAdmin', id];
					break;
				case 'create-issue':
					crumbs = [{ text: 'Create Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/Create/' + id];
					break;
				case 'edit-issue':
					crumbs = [{ text: 'Edit Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/Edit/' + issueId];
					break;
				case 'schedule-issue':
					crumbs = [{ text: 'Schedule Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/ScheduleNewsletterIssue/?issueId=' + issueId + '&goBackPage=' + goBackPage];
					break;
				case 'distribute-issue':
					crumbs = [{ text: 'Distribution' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/DistributeNewsletterIssue/?issueId=' + issueId + '&goBackPage=' + goBackPage];
					break;
				case 'send-test-issue':
					crumbs = [{ text: 'Send Test Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/ScheduleNewsletterIssue/?issueId=' + issueId + '&goBackPage=' + goBackPage + '&isTest=true'];
					break;
				case 'reschedule-issue':
					crumbs = [{ text: 'Schedule Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/ReScheduleNewsletterIssue/?issueId=' + issueId + '&postId=' + postId + '&goBackPage=' + goBackPage];
					break;
				case 'schedule':
					crumbs = [{ text: 'Schedule Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/ScheduleNewsletterIssueForDocument/?id=' + issueId];
					break;
				case 'send-test':
					crumbs = [{ text: 'Send Test Issue' }];
					args = ['render:urlcontent', self, url + '/NewsletterIssues/ScheduleNewsletterIssueForDocument/?id=' + issueId + '&isTest=true'];
					break;
				case 'overview':
				default:
					crumbs = [{ text: 'List Overview' }];
					view = 'NewsletterListOverview';
					viewOptions = {
						id: id
					};
					break;
			}


			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});

			if (args) {
				self.options.dispatcher
					.trigger.apply(self.options.dispatcher, args);
			} else if (view) {
				LA.ActiveView = new LA.Views[view](viewOptions);
			}

		},
		renderUrlContent: function (self, url) {
			LA.ajax({ url: url, type: 'GET' }, function (resp) {
				self.setContent(resp, { 'padding': '0 10px 0 0' });
			});
		},

		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:newsletterListSideNav', bool);
			this.resizeContent();
		},
		setNewsletterListContent: function (content) {
			self.setContent(content, { 'padding': '0 10px 0 0' });
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');

			this.resetChildren();
		}
	}));
	/*----------------*/

	/* This initializes the dashboard view for a single Newsletter List */
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.NewsletterListContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.NewsletterListDashboard(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/

	/* Administration view for a single Newsletter List */
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.NewsletterListAdmin = Backbone.View.extend($.extend({}, {
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:newsletterListAdmin', this.render);
		},
		render: function (id) {
			var self = this;

			// Do Get
			LA.ajax({
				url: LA.Path + '/NewsletterLists/Edit',
				type: 'GET',
				data: { listId: id }
			}, function (resp) {
				self.$el.empty().html(resp);
			});
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).

		}
	}));
	/*----------------*/

	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionPosts = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.models = options.models;

			_.bindAll(this, 'renderCreatePost', 'renderCreateDirectPost', 'renderEditPost');

			this.options.dispatcher
				.on('render:promoCreatePost', this.renderCreatePost)
				.on('render:promoCreateDirectPost', this.renderCreateDirectPost)
				.on('render:promoEditPost', this.renderEditPost);
		},
		renderCreatePost: function (type, id) {
			var self = this;
			// Do Get
			LA.ajax({
				url: LA.Path + '/Posts/Create',
				type: 'GET',
				data: { promoId: this.models.Promo.get('id'), type: type, docId: id }
			}, function (resp) {
				self.options.dispatcher
					.trigger('set:promoContent', resp, { 'padding': '0 10px 0 0' });
			});
		},
		renderCreateDirectPost: function (type) {
			var self = this;
			var url;

			if (type === 1) {
				url = LA.Path + '/Posts/CreateFacebookDirect?promoId=' + this.models.Promo.get('id');
			}
			else if (type === 3) {
				url = LA.Path + '/Posts/CreateNovSelectDirect?promoId=' + this.models.Promo.get('id');
			}

			// Do Get
			LA.ajax({
				url: url,
				type: 'GET'
			}, function (resp) {
				self.options.dispatcher
					.trigger('set:promoContent', resp, { 'padding': '0 10px 0 0' });
			});
		},
		renderEditPost: function (type, id) {
			var self = this;
			// Do Get
			LA.ajax({
				url: LA.Path + '/Posts/Edit' + type + '/' + id,
				type: 'GET'
			}, function (resp) {
				self.options.dispatcher
					.trigger('set:promoContent', resp, { 'padding': '0 10px 0 0' });
			});
		}
	});



	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.TemplateGalleryInfo = function (options) {
		for (var p in options) {
			if (options.hasOwnProperty(p)) {
				this[p] = options[p];
			}
		}
	};

	LA.GalleryTypes = {
		PROMOTION: "Promotion",
		COPYTEMPLATE: "CopyTemplate"
	};

	var promotionTemplateGalleryInfo = new LA.TemplateGalleryInfo({
		galleryType: LA.GalleryTypes.PROMOTION,
		mainRenderEvent: "render:promoCreateItem",
		contentSetEvent: "set:promoContent",
		deliveryTypeFetchEvent: "fetch:promoDeliveryTypes",
		templatesFetchEvent: "fetch:promoTemplates",
		formatTypeFetchEvent: "fetch:promoFormatTypes",
		widgetFetchEvent: 'fetch:promoWidgets', //this is only used if requireWidgetToBeSelectedBeforeShowingTemplates is true
		templatePreviewClearEvent: "clear:promoTemplatePreview",
		templatePreviewRenderEvent: 'render:promoTemplatePreview',
		heading: "Create Item",
		helpTarget: '88269',
		selectTemplateButtonText: 'Select This Template',
		requireWidgetToBeSelectedBeforeShowingTemplates: true,
		showOrganizationInPreview: false
	});

	var copyTemplateGalleryInfo = new LA.TemplateGalleryInfo({
		galleryType: LA.GalleryTypes.COPYTEMPLATE,
		mainRenderEvent: "render:copyTemplateGallery",
		contentSetEvent: "set:adminContent",
		deliveryTypeFetchEvent: "fetch:copyTemplateDeliveryTypes",
		templatesFetchEvent: "fetch:copyTemplateTemplates",
		formatTypeFetchEvent: "fetch:copyTemplateFormatTypes",
		templatePreviewClearEvent: "clear:copyTemplateTemplatePreview",
		templatePreviewRenderEvent: 'render:copyTemplateTemplatePreview',
		heading: 'Copy Template',
		helpTarget: '204162',
		selectTemplateButtonText: 'Create Copy',
		requireWidgetToBeSelectedBeforeShowingTemplates: false,
		showOrganizationInPreview: true
	});
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionTemplatePreview = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.models = options.models;
			this.galleryInfo = options.galleryInfo;
			this.template = LA.filterTemplates(/^Promos\/TmplPreview$/).TmplPreview;

			_.bindAll(this, 'render', 'createDoc', 'createPost', 'clear', 'reset');

			this.options.dispatcher
				.on(this.galleryInfo.templatePreviewRenderEvent, this.render)
				.on(this.galleryInfo.templatePreviewClearEvent, this.clear);
		},
		render: function (tmpl) {
			var self = this,
				data = tmpl.toJSON(),
				imgEl,
				$img,
				$noImg,
				$file,
				$loading,
				$span;

			this.$el
				.empty()
				.html(this.template({ t: data, keywordList: data.keywords.join(', '), galleryInfo: this.galleryInfo }));

			$img = this.$('img.lazy');
			if ($img.length > 0) {
				imgEl = $img.get(0);

				$file = $img.parent();
				$loading = $file.prev();

				imgEl.onload = function () {
					$loading.hide();
					$img.removeClass('lazy').removeAttr('data-src');
					$file.fadeIn('fast');
					$span = $img.next();

					if ($span != null) {
						var spanTop = (($img.height() - 32) + Math.floor(($file.height() - $img.height()) / 2)) + 'px';
						var spanLeft = (($img.width() - 31) + Math.floor(($file.width() - $img.width()) / 2)) + 'px';
						$span.css({ 'top': spanTop, 'left': spanLeft });
					}
				};
				imgEl.src = $img.attr('data-src');

				$img.on('click.promoTemplatePreview', function (e) {
					var el = $(e.currentTarget),
						id = el.attr('data-val'),
						url = LA.WebRoot + LA.OrganizationId + '/Documents/DraftView/' + id;

					$('<div><iframe src="' + url + '" style="width:900px;height:458px;"></iframe></div>').modal({
						title: 'Template Preview',
						width: 940,
						height: 580,
						zIndex: 100010,
						buttons: [{ text: 'Close' }],
						show: true
					});
				});
			} else {
				$noImg = $('div.no-img', this.$el);
				$file = $noImg.parent();
				$file.fadeIn('fast').prev().hide();
			}

			this.$('#action.tmpl>button').on('click.promoTemplateSelectAction', function () {
				var id = parseInt($(this).attr('data-val'), 10);
				self.createDoc(id);
			});
			this.$('#action.social>button').on('click.promoTemplateSocialAction', function () {
				var type = $(this).attr('data-val');
				self.createPost(type);
			});
		},
		createDoc: function (id) {
			var urlPath = LA.Path;
			switch (this.galleryInfo.galleryType) {
				case LA.GalleryTypes.PROMOTION:
					urlPath += '/Documents/CreateFromTemplate/' + id + '?contextId=' + this.models.Promo.get('correlationId') + '&editorContext=Promotion';
					break;
				case LA.GalleryTypes.COPYTEMPLATE:
					urlPath += '/Documents/CopyTemplate/' + id;
					break;
			}
			window.location = urlPath;
		},
		/**
		 * @deprecated ??? 
		 */
		createPost: function (type) {
			var promoId = this.models.Promo.get('id');
			if (type === 'Facebook') {
				LA.AppRouter.navigate('#!/promotions/' + promoId + '/create-facebook-post', { trigger: true });
			}
		},
		clear: function () {
			this.reset();
			this.$el.empty();
		},
		reset: function () {
			this.$('img').off('click.promoTemplatePreview');
			this.$('#action.tmpl>button').off('click.promoTemplateSelectAction');
			this.$('#action.social>button').off('click.promoTemplateSocialAction');
		}
	});
	/*----------------*/
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Views.PromotionTemplatesTypes = Backbone.View.extend({
		initialize: function (options) {
			var self = this;
			this.options = options;
			this.galleryInfo = options.galleryInfo;
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter({ format: null, audience: null, searchTerm: null, widgetId: { id: null, name: null } })
			});
			this.template = LA.filterTemplates(/^Promos\/Tmpl$/).Tmpl;

			_.bindAll(this, 'render', 'fetch', 'clickTmpl', 'reset');

			this.options.dispatcher
				.on(this.galleryInfo.templatesFetchEvent, this.fetch);


			this.collection
				.on('add', this.render)
				.on('remove', this.render)
				.on('reset', this.render);
		},
		render: function () {
			var self = this,
				$filters = this.$('#filters'),
				$items = this.$('#items'),
				$widgetLabel,
				$search,
				filterGallery = function () {
					var searchVal = $search.val(),
						format = self.models.Filter.get('format'),
						widgetFormat = self.models.Filter.get('widgetFormat');

					self.fetch(format, searchVal, widgetFormat);

				},
				selectedFormat = self.models.Filter.get('format'),
				isWidget = selectedFormat.toLowerCase() === "widgets";

			this.$el.show().parent().find("#widgets").hide();
			this.$el.parent().find("#preview").show();
			if ($filters.is(':empty')) {
				// Setup elements
				$search = $('<input />', { 'id': 'search', 'class': 'input-medium search-query', 'placeholder': 'Search for a template by name or keywords' }).appendTo($filters);
				$widgetLabel = $('<div id="widget-label"><label>Current Widget Dimensions: </label><a href="javascript:;" title="Click to change">You have a widget!</a></div>').appendTo($filters);
				// Setup events
				$search.on('keyup.promoTemplatesSearch', _.debounce(filterGallery, 300));
				if (this.galleryInfo.requireWidgetToBeSelectedBeforeShowingTemplates) {
					$widgetLabel.on('click', "a", function () {
						self.options.dispatcher.trigger(this.galleryInfo.widgetFetchEvent);
					});
				}
			} else {
				$search = $('#search');
				$widgetLabel = $("#widget-label");

			}

			if (isWidget && this.galleryInfo.requireWidgetToBeSelectedBeforeShowingTemplates) {
				var widgetFormat = self.models.Filter.get('widgetFormat').name;
				var formatExtractorRegex = /\((.*?)\)/;
				var match = formatExtractorRegex.exec(widgetFormat);
				$widgetLabel.find("a").text(match[1]);
				$widgetLabel.show();

			} else {
				$widgetLabel.hide();
			}

			$items.empty();
			// If empty
			if (this.collection.size() === 0) {
				$items.html('<p>** There are no templates for this format at this time.  Please check back soon.</p>');
				this.options.dispatcher
					.trigger(this.galleryInfo.templatePreviewClearEvent);
			} else {
				// Not empty... display
				this.collection.each(function (tmpl) {
					$items.append(self.template({ t: tmpl.toJSON() }));
				});

				$('img.lazy', $items).each(function (idx, element) {
					var $img = $(element),
						img = $img.get(0),
						$file = $img.parent().parent(),
						$loading = $file.prev();

					img.onload = function () {
						$loading.hide();
						$img.removeClass('lazy').removeAttr('data-src');
						$file.fadeIn('fast').css({ 'display': 'table-cell' });

						$img.hover(
							function () { $(this).addClass('hover'); },
							function () { $(this).removeClass('hover'); }
						);
					};
					img.src = $img.attr('data-src');
				});
				$('div.no-img', $items).each(function (idx, element) {
					var $div = $(element);
					$div.parent().fadeIn('fast').prev().hide();

					$div.hover(
						function () { $(this).addClass('hover'); },
						function () { $(this).removeClass('hover'); }
					);
				});

				this.$('#items>.tmpl>.file>.fileinner').children(':first').click();
			}
		},
		fetch: function (format, searchTerm, widgetFormat) {
			widgetFormat = widgetFormat || { id: null, name: null };

			this.models.Filter
				.set({ format: format, searchTerm: searchTerm, widgetFormat: widgetFormat });
			// Get some data from Templates/GetTemplates
			this.collection
				.fetch({
					data: {
						format: format,
						contextId: (this.models.Promo && this.models.Promo.get('correlationId')),
						audience: '',
						searchTerm: searchTerm || '',
						widgetFormatId: widgetFormat.id || '',
						galleryType: this.galleryInfo.galleryType,
						editorType: this.options.getEditorType()
					},
					reset: true
				});
		},
		clickTmpl: function (e) {
			var el = $(e.currentTarget),
				id = el.attr('data-val');

			this.$('img').removeClass('selected');
			this.$('#items>.tmpl>.file').children().removeClass('selected');
			el.addClass('selected');

			var tmpl = this.collection.get(id);
			this.options.dispatcher
				.trigger(this.galleryInfo.templatePreviewRenderEvent, tmpl);
		},
		reset: function () {
			this.$('#search').off('keyup.promoTemplatesSearch');
		}
	});
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionWidgetTypes = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.galleryInfo = options.galleryInfo;
			this.models = options.models;
			this.template = LA.filterTemplates(/^Promos\/Widgets$/).Widgets;

			_.bindAll(this, 'render', 'fetch');
			this.options.dispatcher.on(this.galleryInfo.widgetFetchEvent, this.fetch);
			this.collection
				.on('add', this.render)
				.on('remove', this.render)
				.on('reset', this.render);
		},
		render: function () {
			var self = this;
			var $collection = this.$("#widget-collection");
			var instructionText = this.$("#widget-instruction-text");
			this.$el.show().parent().find("#templates").hide();
			this.$el.parent().find("#preview").hide();

			$collection.empty();
			// NOTE: We need to unbind any previously bound onClick events that are bound to each ".widget-selection" element in order
			// to prevent calling said event n+1 times. This needs to happen at this point, before we call $collection.on() below which is
			// what actually wires up the event listener to the onClick event.
			$collection.off("click");

			if (this.collection.length > 0) {
				instructionText.show();
				this.collection.each(function (widget) {
					//see http://backbonejs.org/#Model-toJSON for confusing method name explanation
					var widgetAttrs = widget.toJSON();
					var targetMax = 100;
					var scale;
					if (widgetAttrs.width > widgetAttrs.height) {
						//scale off width
						scale = widgetAttrs.width > targetMax ? targetMax / widgetAttrs.width : 1.0;
					} else {
						//scale off height
						scale = widgetAttrs.height > targetMax ? targetMax / widgetAttrs.height : 1.0;
					}

					widgetAttrs.scaledHeight = Math.round(widgetAttrs.height * scale);
					widgetAttrs.scaledWidth = Math.round(widgetAttrs.width * scale);
					var formatExtractorRegex = /\((.*?)\)/;
					var match = formatExtractorRegex.exec(widgetAttrs.format);
					widgetAttrs.displayFormat = match[1];
					$collection.append(self.template(widgetAttrs));
				});
			} else {
				instructionText.hide();
				$collection.html('<p>Your organization does not currently have any active Widget Containers. Please go to the <a href="#!/admin/widgets/promotion">Admin -> Widgets</a> tab to configure Widget Containers.</p>');

			}

			// When this View renders, we're binding a call to fetch the Widgets for each widget format available to the user.
			$collection.on("click", ".widget-selection", function () {
				var $widget = $(this);
				var widgetId = $widget.attr('data-widget-id');
				var widget = self.collection.get(widgetId);

				self.options.dispatcher.trigger(self.galleryInfo.templatesFetchEvent, 'Widgets', null, { name: widget.get('format'), id: widget.get('formatId') });
			});
		},
		fetch: function () {
			this.collection.fetch({ reset: true });
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionFormatTypes = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.galleryInfo = options.galleryInfo;
			this.models = options.models;
			this.template = _.template('<li><a href="javascript:;" class="<%=displayClass%>" data-val="<%=name%>"><%=name%></a></li>');

			_.bindAll(this, 'render', 'fetch', 'empty', 'clickType');

			this.options.dispatcher
				.on(this.galleryInfo.formatTypeFetchEvent, this.fetch);

			this.collection
				.on('add', this.render)
				.on('remove', this.render)
				.on('reset', this.render);
		},
		render: function () {
			var self = this;
			this.$el.empty();
			this.collection.each(function (type) {
				self.$el.append(self.template(type.toJSON()));
			});

			if (this.collection.length === 0) {
				self.$el.append('<li><a data-val="none">N/A</a></li>');
			}

			var $selectedFormatLink;

			if (self.selectedFormatName) {
				$selectedFormatLink = self.$('a[data-val="' + self.selectedFormatName + '"]');
			}

			if (!$selectedFormatLink || $selectedFormatLink.length === 0) {
				$selectedFormatLink = self.$('a:first');
			}

			$selectedFormatLink.click();
		},
		fetch: function (id) {
			this.collection
				.fetch({ data: { type: id, galleryType: this.galleryInfo.galleryType }, reset: true });
		},
		empty: function () {
			this.$el.empty();
		},
		clickType: function (e) {
			var el = $(e.target),
				format = el.attr('data-val');

			this.$('a').removeClass('selected');
			el.addClass('selected');

			if (format.toLowerCase() === "widgets" && this.galleryInfo.requireWidgetToBeSelectedBeforeShowingTemplates) {
				this.options.dispatcher.trigger(this.galleryInfo.widgetFetchEvent);
			} else {
				this.options.dispatcher.trigger(this.galleryInfo.templatesFetchEvent, format);
			}
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionDeliveryTypes = Backbone.View.extend({
		initialize: function (options) {
			var self = this;
			this.options = options;
			this.galleryInfo = options.galleryInfo;
			this.models = options.models;
			this.template = _.template('<li><a href="javascript:;" class="<%=displayClass%>" data-template-type-name="<%=name%>" data-val="<%=id%>" data-editor-type="<%=editorTypeID%>"><%=name%></a></li>');

			_.bindAll(this, 'render', 'fetch', 'clickType');

			this.options.dispatcher
				.on(this.galleryInfo.deliveryTypeFetchEvent, this.fetch);

			this.collection
				.on('add', this.render)
				.on('remove', this.render)
				.on('reset', this.render);
		},
		render: function () {
			var self = this;
			var indexMap = {};
			var isDragAndDropEditorEnabled = false;
			this.$el.empty();
			this.collection.each(function (type) {
				self.$el.append(self.template(type.toJSON()));
				if (type.get('editorTypeID') === 2) {
					isDragAndDropEditorEnabled = true;
				}
				indexMap[type.get('actionFragment')] = type.get('id');
			});

			var $link = null;

			if (self.type && indexMap[self.type] >= 0) {
				$link = this.$('a[data-val=' + indexMap[self.type] + ']');
			}

			if (!$link || $link.length === 0) {
				if (isDragAndDropEditorEnabled) {
					$link = this.$('a[data-val="' + indexMap['printdraganddrop'] + '"]');
				} else {
					$link = this.$('a[data-val]:first');
				}
			}

			$link.click();
		},
		fetch: function () {
			this.collection
				.fetch({ data: { galleryType: this.galleryInfo.galleryType }, reset: true });
		},
		clickType: function (e) {
			var el = $(e.target),
				id = el.attr('data-val');
			this.options.setEditorType(el.attr('data-editor-type'));
			this.$('a').removeClass('selected');
			el.addClass('selected');

			this.options.dispatcher
				.trigger(this.galleryInfo.formatTypeFetchEvent, id);

			var entry = this.collection.toJSON().find(function (item) { return item.id === parseInt(id); });
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE 
	 */
	LA.Views.TemplateGallery = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			var self = this;
			this.options = options;
			this.galleryInfo = options.galleryInfo;
			this.models = options.models;
			this.options.setEditorType = function (editorType) {
				self.editorType = editorType;
			}
			this.options.getEditorType = function () {
				return self.editorType;
			}
			this.template = LA.filterTemplates(/^Templates\/GalleryFrame$/).GalleryFrame;
			this.views = [
				new LA.Views.PromotionDeliveryTypes($.extend({}, this.options, { models: this.models, collection: new LA.Collections.DeliveryTypes() })),
				new LA.Views.PromotionFormatTypes($.extend({}, this.options, { models: this.models, collection: new LA.Collections.FormatTypes() })),
				new LA.Views.PromotionTemplatesTypes($.extend({}, this.options, { models: this.models, collection: new LA.Collections.TemplateTypes(), widgetCollection: new LA.Collections.WidgetTypes() })),
				new LA.Views.PromotionTemplatePreview($.extend({}, this.options, { models: this.models }))
			];
			if (this.galleryInfo.requireWidgetToBeSelectedBeforeShowingTemplates) {
				this.views.push(new LA.Views.PromotionWidgetTypes($.extend({}, this.options, { models: this.models, collection: new LA.Collections.WidgetTypes() })));
			}
			_.bindAll(this, 'render', 'reset');

			this.options.dispatcher
				.on(this.galleryInfo.mainRenderEvent, this.render);
		},
		render: function (type, selectedFormatName) {
			this.options.dispatcher
				.trigger(this.galleryInfo.contentSetEvent, this.template(this.galleryInfo));

			this.views[0].type = type;
			this.views[1].type = type;

			if (selectedFormatName) {
				this.views[1].selectedFormatName = selectedFormatName;
			}

			this.views[0]
				.setElement(this.$('#choices>#left>.simple-side-nav'))
				.delegateEvents({ 'click a': 'clickType' });
			this.views[1]
				.setElement(this.$('#choices>#right>.simple-side-nav'))
				.delegateEvents({ 'click a': 'clickType' });
			this.views[2]
				.setElement(this.$('#templates'))
				.delegateEvents({ 'click img,div.no-img': 'clickTmpl' });

			this.views[3].setElement(this.$('#preview'));
			if (this.galleryInfo.requireWidgetToBeSelectedBeforeShowingTemplates) {
				this.views[4].setElement(this.$('#widgets'));
			}

			this.options.dispatcher
				.trigger(this.galleryInfo.deliveryTypeFetchEvent);
		},
		reset: function () {
			this.resetChildren();
		}
	}));

	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionReviewItem = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.models = options.models;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:promotionReviewItem', this.render);
		},
		render: function (documentId) {
			var self = this;

			// Do Get
			LA.ajax({ url: LA.Path + '/Documents/Review', type: 'GET', data: { id: documentId } }, function (resp) {
				self.options.dispatcher.trigger('set:promoContent', resp, { 'padding': '0 10px 0 0' });
			});
		}
	});

	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionDetails = Backbone.View.extend($.extend({}, {
		initialize: function (options) {
			this.options = options;
			this.models = options.models;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:promoDetails', this.render);
		},
		render: function () {
			var self = this;
			// Do Get
			LA.ajax({
				url: LA.Path + '/Promotions/Edit',
				type: 'GET',
				data: { id: this.models.Promo.get('id') }
			}, function (resp) {
				self.options.dispatcher
					.trigger('set:promoContent', resp, { 'padding': '0 10px 0 0' });
			});
		}
	}));
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionPublications = Backbone.View.extend($.extend({}, {
		events: {
			'change #ChannelTypeFilter': 'updateFilters',
			'filterChanged .promotion-publications [data-userstarfilter]': 'filterChanged'
		},
		initialize: function (options) {
			this.options = options;
			this.template = options.template;
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter(),
				Payload: new LA.Models.Payload()
			});

			_.bindAll(this, 'render',
				'resizePosts',
				'fetchItems',
				'displayItems',
				'scrollList',
				'filterChanged',
				'updateFilters',
				'setFilter',
				'reset');

			this.options.dispatcher
				.on('render:promoPublications', this.render)
				.on('update:promoPublicationItems', this.updateFilters);

			this.on('fetch:PublicationItems', this.fetchItems);
			this.models.Filter.on('change', this.fetchItems);
			this.models.Payload.on('change', this.displayItems);
		},
		render: function () {
			var self = this,
				resizeHandler,
				scrollHandler;

			//Ajax call to load the partial view "_PublicationSchedule"
			LA.ApplicationState.Filters.getProperties('DefaultPromotionUserStarFilter').done(function (properties) {
				LA.ajax({
					url: LA.Path + '/Posts/GetPublicationSchedule',
					type: 'GET',
					data: { orgId: LA.OrganizationId }
				}, function (resp) {
					self.$el.empty().html(resp);
					self.models.Filter.clear({ silent: true });
					self.models.Filter.set({ pageNum: 1, pageSize: 12, firstTimeRender: true, starFilterType: properties.DefaultPromotionUserStarFilter });
					self.resizePosts();
					$('.promotion-publications [data-userstarfilter] [data-starvalue="' + properties.DefaultPromotionUserStarFilter + '"]').addClass('active').siblings().removeClass('active');
				}, function () {
					resizeHandler = _.debounce(function () { self.resizePosts(); }, 100);
					scrollHandler = _.debounce(function (e) { self.scrollList(e); }, 300);

					$(window).on('resize.items', resizeHandler);
					self.$('#posts')
						.on('scroll.posts', scrollHandler)
						.on('scroll.posts', _.throttle(function () {
							$('.widget-post', self.$el).qtip('toggle', false);
						}, 300));
				});
			});
		},
		resizePosts: function () {
			this.$('#posts')
				.css('height', this.$el.height() - this.$('.row-fluid.heading').height());
		},
		fetchItems: function () {
			var self = this;
			this.models.Filter.set({ contextId: this.models.Promo.get('correlationId') }, { silent: true });

			//Load the data, and the list of social accounts simultaneously.
			async.parallel([
				function (callback) {
					//Ajax call to get the data to be loaded into the template
					LA.ajax({
						url: LA.Path + '/Posts/GetPublicationsSchedule',
						type: 'GET',
						data: self.models.Filter.toJSON(),
						dataType: 'json'
					}, function (resp) {
						callback(null, resp);
					});
				},
				LA.Utility.validateSocialMediaCache
			],
				function (err, results) {
					if (!err) {
						var resp = results[0];
						// We always want to trigger the change event, so clear the model silently then set to force change.
						self.options.dispatcher
							.trigger('set:promoSideNavModel', { postCount: resp.TotalItemCount }, { clear: false });
						self.models.Payload.clear({ silent: true });
						self.models.Payload.set(resp);
					}
				});
		},
		displayItems: function () {
			var self = this;
			var pageNum = this.models.Filter.get('pageNum');
			var doRender = pageNum === 1;
			var payload = this.models.Payload.toJSON();
			var filter = this.models.Filter.toJSON();
			var tmplData = {
				data: payload.Data,
				filters: {
					isSearch: filter.isSearch,
					pageNum: filter.pageNum,
					pageSize: filter.pageSize,
					pageCount: payload.pageCount,
					isFirstPage: payload.IsFirstPage,
					isLastPage: payload.IsLastPage,
					hasPreviousPage: payload.HasPreviousPage,
					hasNextPage: payload.HasNextPage,
					totalItemCount: payload.TotalItemCount,
					starFilterType: filter.starFilterType
				}
			};
			$('#ChannelTypeFilter').val(filter.channelType);
			//Add the filled template to the  'list-posts' div

			if (doRender) {
				this.$('#list-posts').empty().html(this.template({ data: { starFilterType: filter.starFilterType, items: tmplData.data } }));
				var postCount = tmplData.filters.totalItemCount;

				$('#posted-Item-Count').empty().html(postCount);
				//this line ensures that the underlying promotion model is kept up-to-date so that further renders will have the right post count
				self.options.dispatcher
					.trigger('set:promoSideNavModel', { postCount: postCount }, { clear: false, silent: true });
			} else {
				this.$('#list-posts').append(this.template({ data: { starFilterType: filter.starFilterType, items: tmplData.data } }));
			}

			this.models.Filter.set({ 'pageNum': ++pageNum }, { silent: true });

		},
		scrollList: function (e) {
			commonScrollList(this, e, 'pageNum', 'fetch:PublicationItems');
		},
		filterChanged: function (evt) {

			var channelType = this.$('#ChannelTypeFilter').val();
			var filterOptions = {
				starFilterType: evt.filterValue,
				channelType: (_.isUndefined(channelType) ? null : channelType),
				pageNum: 1
			};

			this.setFilter(filterOptions);
		},
		updateFilters: function () {
			var channelType = this.$('#ChannelTypeFilter').val();

			var filterValues = {
				channelType: (_.isUndefined(channelType) ? null : channelType),
				pageNum: 1
			};
			this.setFilter(filterValues);
		},
		setFilter: function (data, options) {
			this.models.Filter.set(data, $.extend({}, { silent: false }, options));
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window)
				.off('resize.posts')
				.off('resize.postsGrid');
			//JIRA:LIBRARYAWARE-1242
			//This call is being made elsewehere in this file, but not here previously.  This is because we dont explicitly call delegate events in the initialize.
			//However, it is called implicitly by backbone, delegating the events listed above.
			//However, contrary to popular opinion, these events arent delegated only when this view is "active", but rather throughout the whole application
			//causing all a.btn elements to behave in a manner consistent with the logic in toggle view.
			//since reset is called (by convention) any time a view is swapped out, this will fix the issue
			//not entirely sure why the promotion dashboard still works, as it would appear that the elements are still delegated there;
			//which is what we want.
			this.undelegateEvents();
		}
	}));

	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionExistingItems = Backbone.View.extend($.extend({}, LA.Views.Mixins.DocumentManagement, {
		events: {
			'filterChanged .promotionExistingItems [data-userstarfilter]': 'updateFilter'
		},
		initialize: function (options) {
			this.options = options;
			this.template = options.template;
			this.models = $.extend({}, options.models, {
				Filter: new LA.Models.Filter(),
				Payload: new LA.Models.Payload()
			});

			_.bindAll(this, 'render',
				'resizeList',
				'scrollList',
				'fetchItems',
				'updateFilter',
				'displayItems',
				'onDeleteSuccess',
				'reset',
				'previewDocument',
				'deleteDocument');

			this.options.dispatcher
				.on('render:promoExistingItems', this.render)
				.on('preview:promoItem', this.previewDocument)
				.on('delete:promoItem', this.deleteDocument);

			this.on('fetch:items', this.fetchItems);

			this.models.Filter
				.on('change', this.fetchItems);
			this.models.Payload
				.on('change', this.displayItems);
		},
		render: function () {
			var self = this,
				resizeHandler,
				scrollHandler;

			// Do Get
			LA.ApplicationState.Filters.getProperties('DefaultPromotionUserStarFilter').done(function (properties) {
				LA.ajax({
					url: LA.Path + '/Documents/List',
					type: 'GET',
					data: { promoId: self.models.Promo.get('id') }
				}, function (resp) {
					self.models.Promo.fetch();

					self.$el.empty().html(resp);
					self.models.Filter.clear({ silent: true });
					self.models.Filter.set({ contextId: self.models.Promo.get('correlationId'), promoId: self.models.Promo.get('id'), page: 1, size: 50, starFilterType: properties.DefaultPromotionUserStarFilter });
					// make the proper filter button active
					$('.promotionExistingItems [data-userstarfilter] [data-starvalue="' + properties.DefaultPromotionUserStarFilter + '"]').addClass('active').siblings().removeClass('active');

					self.resizeList();
				}, function () {
					resizeHandler = _.debounce(function () { self.resizeList(); }, 100);
					scrollHandler = _.debounce(function (e) { self.scrollList(e); }, 300);

					$(window).on('resize.items', resizeHandler);
					self.$('#docs')
						.on('scroll.items', scrollHandler)
						.on('scroll.items', _.throttle(function () {
							$('.file, div.name>a', self.$el).qtip('toggle', false);
						}, 300));

					//unbinding because this function gets called every time the "Items" "tab" is rendered
					//but we need to make sure that the data-item-action is only bound once (otherwise, the dialog will come up several times)
					//this isn't an issue with the scroll handlers above because #docs gets replaced every time
					//HOWEVER, the [data-item-action] things are rendered OUTSIDE #docs (at least when they're visible).
					$('body').off('click', 'a[data-item-action]');
					$('body').on('click', 'a[data-item-action]', function () {
						var action = $(this).attr('data-item-action');
						var itemId = $(this).attr('data-item-id');
						if (action === "copy") {
							copyDocument(itemId).then(function (data) {
								if (data.newContext && data.newContext.BackboneRouteBase) {
									var newLocation = data.newContext.BackboneRouteBase;
									LA.ApplicationState.createdDocumentId = data.newDocumentId;
									//sadly (or maybe not) the naviation will only happen
									//if the hash isn't already equal to where we are
									//so we have to manually check if we're in the same context
									//and reset the filter to Fetch (and make the newly created item show up)
									if (newLocation === window.location.hash) {
										//note: there is an edge case here where the created document is NOT on the first page
										//however, that edge is VERY narrow.
										//I'm leaving this as a known case and logging a ticket to resolve at a later date
										self.models.Filter.set({ page: 1 });
									} else {
										LA.AppRouter.navigate(newLocation, { trigger: true });
									}
								}
							});
						}
					});
				});
			});
		},
		resizeList: function () {
			this.$('#docs')
				.css('height', this.$el.height() - this.$('.row-fluid.heading').outerHeight(true));
		},
		scrollList: function (e) {
			commonScrollList(this, e, 'page', 'fetch:items');
		},
		fetchItems: function () {
			var self = this;

			// Do Get
			LA.ajax({ url: LA.Path + '/Documents/GetDocuments', type: 'GET', data: this.models.Filter.toJSON(), dataType: 'json' }, function (resp) {
				// We always want to trigger the change event, so clear the model
				// silently then set to force change.
				self.options.dispatcher
					.trigger('set:promoSideNavModel', { docCount: resp.TotalItemCount }, { clear: false });
				self.models.Payload.clear({ silent: true });
				self.models.Payload.set(resp);
			});
		},
		updateFilter: function (e) {
			this.models.Filter.set({ page: 1, starFilterType: e.filterValue });

		},
		displayItems: function () {
			var page = this.models.Filter.get('page'),
				doRender = page === 1,
				payload = this.models.Payload.toJSON(),
				filter = this.models.Filter.toJSON(),
				content = this.template({ data: payload.Data, promoId: filter.promoId });

			if (doRender) {
				this.$('#docs').empty().html(content);
			} else {
				this.$('#docs').append(content);
			}
			if (LA.ApplicationState.createdDocumentId) {
				var newElement = this.$('[data-item-id=' + LA.ApplicationState.createdDocumentId + ']');
				flashBackground(newElement, 'background-whitesmoke');
			}
			this.loadImages();
			this.setupDocumentDetails();

			this.models.Filter.set({ 'page': ++page }, { silent: true });
		},

		onDeleteSuccess: function () {
			var self = this;

			var docCount = self.models.Promo.get('docCount') - 1;
			// This updates the menu
			self.options.dispatcher
				.trigger('set:promoSideNavModel', { docCount: docCount }, { clear: false });
			// Update model
			self.models.Promo.set('docCount', docCount);
			// This gets fetches the list of documents again.
			self.models.Filter.set({ page: 1 });
		},

		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.items');
			this.$('#docs').off('scroll.items');
			this.unbindDocumentManagementEvents();
			$('body').off('click', 'a.doc-details-preview');
			$('body').off('click', 'a[data-item-action]');
		}
	}));

	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionDashboard = Backbone.View.extend($.extend(LA.Mixins.View, LA.Mixins.SideBarLayout, {
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Promos\/Dashboard/);
			this.galleryInfo = promotionTemplateGalleryInfo;
			this.models = {
				Promo: new LA.Models.Promo()
			};

			this.views = [
				new LA.Views.SideNav($.extend({}, this.options, { model: new LA.Models.ComplexNav(), template: this.templates.DashboardSideNav, selectEvent: 'select:promoSideNav', setEvent: 'set:promoSideNavModel', showEvent: 'show:promoSideNav' })),
				new LA.Views.PromotionExistingItems($.extend({}, this.options, { template: this.templates.DashboardListItems, models: this.models })),
				new LA.Views.PromotionPublications($.extend({}, this.options, { template: this.templates.DashboardPublication, models: this.models })),
				new LA.Views.PromotionDetails($.extend({}, this.options, { models: this.models })),
				new LA.Views.TemplateGallery($.extend({}, this.options, { models: this.models, galleryInfo: this.galleryInfo })),
				new LA.Views.PromotionPosts($.extend({}, this.options, { models: this.models })),
				new LA.Views.PromotionReviewItem($.extend({}, this.options, { models: this.models }))
			];

			_.bindAll(this, 'fetch',
				'render',
				'renderCrumbsAndChild',
				'resize',
				'setPromoModel',
				'reset',
				'setContent');

			this.options.dispatcher
				.on('fetch:promoModel', this.fetch)
				.on('render:promoDashboard', this.render)
				.on('resize:promoLayout', this.resize)
				.on('set:promoModel', this.setPromoModel)
				.on('set:promoContent', this.setContent);
		},
		fetch: function (promoId, action, type, id) {
			var self = this;
			// Check to see if the model has already been loaded, if not get it.
			if (parseInt(this.models.Promo.get('id'), 10) !== parseInt(promoId, 10)) {
				// Set so call to model fetch will know what promo to ask for.
				this.models.Promo.set('id', promoId);
				LA.ApplicationState.Filters.getProperties('DefaultPromotionUserStarFilter').done(function (properties) {
					self.models.Promo.fetch({
						data: $.param({ starFilterType: properties.DefaultPromotionUserStarFilter }),
						success: function (model) {
							// Set nav model, this will cause side nav to render
							self.options.dispatcher
								.trigger('set:promoSideNavModel', { id: model.get('id'), docCount: model.get('docCount'), postCount: model.get('postCount'), action: action });
							self.renderCrumbsAndChild(action, type, id);
						},
						error: function (originalModel, error) {
							$('#sidebar-nav').hide();
							$('#sidebar-content').html(error.responseText).css('margin-left', '10px');
							self.options.dispatcher
								.trigger('reset:crumb', this.reset);
						}
					});
				});
			} else {
				// Let the nav model know what action/menu item is chosen without triggering anything.
				self.options.dispatcher
					.trigger('set:promoSideNavModel', { action: action }, { clear: false });
				self.renderCrumbsAndChild(action, type, id);
			}
		},
		render: function () {
			var self = this,
				resizeHandler;

			this.options.dispatcher
				.trigger('set:content', '<div class="container-sidebar-layout"><div class="row"><div id="sidebar-nav"></div><div id="sidebar-content"></div></div></div>', 'promos-dashboard-rendered');

			$.each(this.views, function (idx, view) {
				if (idx === 0) {
					view.setElement(self.$('#sidebar-nav'));
				} else {
					view.setElement(self.$('#sidebar-content'));
				}
			});

			this.resizeContent();
			resizeHandler = _.debounce(function () { self.resizeContent(); }, 100);
			$(window).on('resize.sidebarContent', resizeHandler);
		},
		renderCrumbsAndChild: function (action, type, id) {
			var self = this, crumbs, args, myView, viewOptions;

			this.options.dispatcher
				.trigger('add:crumb', { text: 'Folders', fragment: '#!/folders' }, { isRoot: true })
				.trigger('add:crumb', { text: this.models.Promo.get('name'), fragment: '#!/folders/' + this.models.Promo.get('id') });

			switch (action) {
				case 'create-item':
					crumbs = [{ text: 'Create Item' }];
					args = [self.galleryInfo.mainRenderEvent, type];
					break;
				case 'social-media':
				case 'instagram':
				case 'facebook':
					crumbs = [{ text: 'Create Social Media' }];
					myView = 'SocialMedia';

					//Translate URL fragment into a valid type-name of the relevant social media.
					if (action === 'facebook') {
						action = 'FacebookPost';
					} 
					else if (action === 'instagram') {
						action = 'InstagramPost'
					}
					else {
						action = false;
					}

					viewOptions = {
						contextId: this.models.Promo.get('correlationId'),
						promotionId: this.models.Promo.get('id'),
						parent: this,
						accountType: action, //'facebook', etc.
						method: type, //'from-post', 'from-document', etc.
						methodId: id //ID of the post/document.
					};
					break;
				case 'create-post':
					crumbs = [
						{ text: 'Schedule', fragment: '#!/promotions/' + this.models.Promo.get('id') + '/publication' },
						{ text: 'Create Post' }
					];
					args = ['render:promoCreatePost', type, id];
					break;
				case 'create-facebook-post':
					crumbs = [
						{ text: 'Schedule', fragment: '#!/promotions/' + this.models.Promo.get('id') + '/publication' },
						{ text: 'Create Facebook Post' }
					];
					args = ['render:promoCreateDirectPost', 1];
					break;
				case 'edit-post':
					crumbs = [
						{ text: 'Schedule', fragment: '#!/promotions/' + this.models.Promo.get('id') + '/publication' },
						{ text: 'Edit Post' }
					];
					args = ['render:promoEditPost', type, id];
					break;
				case 'item-review':
					crumbs = [{ text: 'Review Item' }];
					args = ['render:promotionReviewItem', type]; //type is actually the id of the document in this case
					break;
				case 'publication':
					crumbs = [{ text: 'Schedule' }];
					args = ['render:promoPublications'];
					break;
				case 'promotional-report':
					crumbs = [{ text: 'Report' }];
					myView = 'PromotionalReportMainView';

					viewOptions = {
						contextId: this.models.Promo.get('correlationId'),
						promotionId: this.models.Promo.get('id'),
						parent: this
					};
					break;
				case 'details':
					crumbs = [{ text: 'Folder Details' }];
					args = ['render:promoDetails'];
					break;
				default:
					crumbs = [{ text: 'Items' }];
					args = ['render:promoExistingItems'];
					break;
			}

			_(crumbs).each(function (crumb) {
				self.options.dispatcher
					.trigger('add:crumb', crumb);
			});

			if (args) {
				this.options.dispatcher.trigger.apply(this.options.dispatcher, args);
			} else if (myView) {
				//This is the proper backbone-sanctioned way to do this.
				LA.ActiveView = new LA.Views[myView](viewOptions);
			}
		},
		resize: function (bool) {
			this.options.dispatcher
				.trigger('show:promoSideNav', bool);
			this.resizeContent();
		},
		setPromoModel: function (obj) {
			this.models.Promo.set(obj);
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.sidebarContent');

			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionsList = Backbone.View.extend({
		events: {
			'click #control-ribbon a.btn': 'toggleButtonState',
			'change #control-ribbon #created': 'updateHash',
			'change #control-ribbon select': 'updateHash'
		},
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^Promos\/List/);
			this.models = {
				Count: new LA.Models.Count({ 'promoCount': Res.Values.Promos.promoCount }),
				Filter: new LA.Models.Filter({ isSearch: false, pageSize: 12, userId: Res.Values.User.Id, starFilterType: LA.ApplicationState.Filters.defaults.DefaultPromotionUserStarFilter }),
				Payload: new LA.Models.Payload({})
			};

			_.bindAll(this, 'render',
				'renderHeading',
				'renderControls',
				'disableControls',
				'resizeList',
				'scrollList',
				'keyUp',
				'toggleButtonState',
				'setFilter',
				'updateHash',
				'fetchPromos',
				'displayPromos',
				'loadImages',
				'createPromoComplete',
				'archivePromo',
				'unArchivePromo',
				'deletePromo',
				'reset');

			// Define globaly accessbile events for this view
			this.options.dispatcher
				.on('render:promosList', this.render)
				.on('set:promofilter', this.setFilter)
				.on('create:promoComplete', this.createPromoComplete)
				.on('archive:promo', this.archivePromo)
				.on('unarchive:promo', this.unArchivePromo)
				.on('delete:promo', this.deletePromo);

			// Define events for this view
			this.on('fetch:promos', this.fetchPromos);

			// Define events for models of this view
			this.models.Count
				.on('change:promoCount', this.renderHeading);
			this.models.Filter
				.on('change', this.fetchPromos);
			this.models.Payload
				.on('change', this.displayPromos);


		},

		render: function () {
			var self = this,
				resizeHandler,
				scrollHandler,
				keyUpHandler;
			this.options.dispatcher
				.trigger('set:content', '<div id="heading"></div><div id="control-ribbon"></div><div id="promos"></div>', 'promos-list-rendered');

			this.renderHeading();
			this.renderControls();
			this.resizeList();

			resizeHandler = _.debounce(function () { self.resizeList(); }, 100);
			scrollHandler = _.debounce(function (e) { self.scrollList(e); }, 300);
			keyUpHandler = _.debounce(function (e) { self.keyUp(e); }, 300);

			$(window).on('resize.promos', resizeHandler);
			this.$('#promos').on('scroll.promos', scrollHandler);
			this.$('#search').on('keyup.promos', keyUpHandler);

			$('#rootCrumb, .btn-section-promotions').on('click', function () {
				var searchVal = $('#search').val();
				if (searchVal && searchVal.length > 0) {
					$('#search').val('').keyup();
				}
			});
		},
		renderHeading: function () {
			this.$('#heading')
				.html(this.templates.ListHeading({ count: this.models.Count.get('promoCount') }));
		},
		renderControls: function () {
			this.$('#control-ribbon')
				.html(this.templates.ListControls());

			this.$statusGroup = this.$('#activestatus .btn-group');
			this.$starredGroup = this.$('#userStarFilter .btn-group');
			this.$activity = this.$('#activity #created');
			this.$directionGroup = this.$('#filters .btn-group');
			this.$column = this.$('#order-by');
		},
		disableControls: function (val) {
			if (val) {
				this.$directionGroup.find('a').addClass('disabled');
				this.$column.attr('disabled', 'disabled');
			} else {
				this.$directionGroup.find('a').removeClass('disabled');
				this.$column.removeAttr('disabled', 'disabled');
			}
		},
		resizeList: function () {
			var inlineStyles = this.$el.attr('style'),
				rules = inlineStyles.split(';'),
				ruleParts,
				style = {};

			for (var i = 0; i < rules.length; i++) {
				ruleParts = rules[i].split(':');
				style[$.trim(ruleParts[0])] = parseInt($.trim(ruleParts[1]), 10);
			}

			this.$('#promos')
				.css('height', style.height - (this.$('#heading').outerHeight(true) + this.$('#control-ribbon').outerHeight(true)));
		},
		scrollList: function (e) {
			commonScrollList(this, e, 'page', 'fetch:promos');
		},
		keyUp: function (/*e*/) {
			this.setFilter({ isSearch: true, page: 1, searchTerm: this.$('#search').val() });
		},
		toggleButtonState: function (e) {
			var $el = $(e.target);
			if ($el.is('i')) {
				$el = $el.parent();
			}
			if ($el.hasClass('btn') && $el.hasClass('disabled')) {
				e.preventDefault();
				return;
			} else {
				if ($el.hasClass('btn') && !$el.hasClass('active')) {
					$el.siblings().removeClass('active');
					$el.addClass('active');
				}
				this.updateHash();
			}
		},
		updateHash: function () {
			var status = this.$statusGroup.find('.active').attr('data-val'),
				starFilterType = this.$starredGroup.find('.active').attr('data-starvalue'),
				activity = this.$activity.is(':checked') ? 'created' : 'all',
				sort = this.$column.val(),
				dir = this.$directionGroup.find('.active').attr('data-val');

			LA.AppRouter.navigate('!/promotions/' + status + '/' + activity + '/' + sort + '/' + dir + '/' + starFilterType, { trigger: true });
		},
		setFilter: function (data, options) {
			var self = this;
			LA.ApplicationState.Filters.getProperties('DefaultPromotionUserStarFilter').done(function (properties) {
				self.models.Filter.set(data, $.extend({}, { silent: false }, options));
				self.$statusGroup.find('a[data-val="' + (self.models.Filter.get('status') === 2 ? 'active' : 'archived') + '"]').addClass('active');
				self.$starredGroup.find('a[data-starvalue="' + (self.models.Filter.get('starFilterType') || properties.DefaultPromotionUserStarFilter) + '"]').addClass('active').siblings().removeClass('active');
				self.$activity.attr('checked', (self.models.Filter.get('activity') === 1 ? true : false));
				self.$column.val(self.models.Filter.get('sort') === 1 ? 'name' : 'date-created');
				self.$directionGroup.find('a[data-val="' + (self.models.Filter.get('dir') === 1 ? 'asc' : 'desc') + '"]').addClass('active');
			});
		},
		fetchPromos: function () {
			var self = this;
			var params = this.models.Filter.toJSON();
			params.recentOnly = false; 	/** @see US593603 - this is a requirement and contract break */
			// Do Get
			LA.ajax({
				url: LA.Path + '/Promotions/GetPromotions',
				type: 'GET',
				data: params,
				dataType: 'json'
			}, function (resp) {
				// We always want to trigger the change event, so clear the model
				// silently then set to force change.
				self.models.Payload.clear({ silent: true });
				self.models.Payload.set(resp);
			});
		},


		displayPromos: function () {
			var page = this.models.Filter.get('page'),
				doRender = page === 1,
				payload = this.models.Payload.toJSON(),
				filter = this.models.Filter.toJSON(),
				tmplData;
			tmplData = {
				webRoot: LA.WebRoot,
				data: payload.Data,
				filters: {
					isSearch: filter.isSearch,
					status: filter.status,
					pageNum: filter.page,
					pageSize: filter.pageSize,
					pageCount: payload.PageCount,
					isFirstPage: payload.IsFirstPage,
					isLastPage: payload.IsLastPage,
					hasPreviousPage: payload.HasPreviousPage,
					hasNextPage: payload.HasNextPage,
					totalItemCount: payload.TotalItemCount
				}
			};

			if (doRender) {
				this.disableControls(this.models.Payload.get('Data').length === 0);
				this.$('#promos').empty().html(this.templates.ListDetails(tmplData));
			} else {
				this.$('#promos').append(this.templates.ListDetails(tmplData));
			}
			this.loadImages();

			this.models.Filter.set({ 'page': ++page }, { silent: true });
		},
		loadImages: function () {
			$('img.lazy', this.$el).each(function (index, element) {
				var $img = $(element),
					img = $img.get(0),
					$wrapper = $img.parent(),
					$file = $wrapper.parent(),
					$loading = $file.prev();
				img.onload = function () {
					$img.removeClass('lazy').removeAttr('data-src');
					$loading.hide();
					$wrapper.fadeIn('fast');
				};
				img.src = $img.attr('data-src');
			});
			$('div.no-image', this.$el).each(function (index, element) {
				var $div = $(element),
					$wrapper = $div.parent(),
					$file = $wrapper.parent(),
					$loading = $file.prev();
				$loading.hide();
				$file.css({ 'width': $wrapper.outerWidth() + 'px' });
				$wrapper.fadeIn('fast');
			});
		},
		createPromoComplete: function (xhr) {
			try {
				var data = JSON.parse(xhr.responseText);
				LA.AppRouter.navigate('#!/promotions/' + data.id, { trigger: true });
			} catch (e) {
				$('[data-chosen=True]').chosen().removeAttr('data-chosen');
			}
		},
		archivePromo: function (id) {
			var self = this;

			var doArchive = function () {
				$.post(LA.Path + '/Promotions/Archive/' + id, function (data) {
					var message = !data.success ? data.error : null;
					if (data.success) {
						Res.Values.Promos.promoCount = data.count;
						self.models.Count.set('promoCount', data.count);
						self.models.Filter.set({ page: 1 });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'Promotion Archive',
							width: 350,
							height: 150,
							backdrop: 'static',
							zIndex: 100010,
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			$('<div>' + Res.Strings.Promos.confirmArchive + '</div>').modal({
				title: 'Confirm Archive',
				width: 350,
				height: 150,
				zIndex: 100010,
				backdrop: 'static',
				show: true,
				buttons: [
					{
						text: 'Yes',
						click: function () {
							doArchive();
							this.hide();
						}
					},
					{
						text: 'Cancel'
					}
				]
			});
		},
		unArchivePromo: function (id) {
			var self = this;

			var doUnArchive = function () {
				$.post(LA.Path + '/Promotions/UnArchive/' + id, function (data) {
					var message = !data.success ? data.error : null;
					if (data.success) {
						Res.Values.Promos.promoCount = data.count;
						self.models.Count.set('promoCount', data.count);
						self.models.Filter.set({ page: 1 });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'Promotion Archive Removal',
							width: 350,
							height: 150,
							zIndex: 100010,
							backdrop: 'static',
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			doUnArchive();
		},
		deletePromo: function (id) {
			var self = this;
			var doDelete = function () {
				$.post(LA.Path + '/Promotions/Delete/' + id, function (data) {
					var message = !data.success ? data.error : null;
					if (data.success) {
						Res.Values.Promos.promoCount = data.count;
						self.models.Count.set('promoCount', data.count);
						self.models.Filter.set({ page: 1 });
					}
					if (message) {
						$('<div>' + message + '</div>').modal({
							title: 'Promotion Delete',
							width: 350,
							height: 150,
							zIndex: 100010,
							backdrop: 'static',
							show: true,
							buttons: [
								{
									text: 'Ok',
									click: function () {
										this.hide();
									}
								}
							]
						});
					}
				}, 'json');
			};
			$('<div>' + Res.Strings.Promos.confirmDelete + '</div>').modal({
				title: 'Confirm Delete',
				width: 350,
				height: 150,
				zIndex: 100010,
				backdrop: 'static',
				show: true,
				buttons: [
					{
						text: 'Delete',
						'class': 'btn-danger',
						click: function () {
							doDelete();
							this.hide();
						}
					},
					{
						text: 'Cancel'
					}
				]
			});
		},
		reset: function () {
			// Unbind events not managed by Backbone View (delegatedEvents).
			$(window).off('resize.promos');
			this.$('#promos').off('scroll.promos');
			this.$('#search').off('keyup.promos');
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionsCreate = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:promosCreate', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/Promotions/Create', type: 'GET' }, function (resp) {
				self.options.dispatcher
					.trigger('set:content', resp, 'promos-create-rendered');
				self.$('[data-chosen=True]').chosen().removeAttr('data-chosen');
				$.validator.unobtrusive.parse(self.$('form'));
			});
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.PromotionsContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.PromotionsCreate(this.options),
				new LA.Views.PromotionsList(this.options),
				new LA.Views.PromotionDashboard(this.options)
			];

			_.bindAll(this, 'reset');
		},
		reset: function () {
			this.resetChildren();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.OrganizationActivate = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:orgActivate', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/Organizations/Activate', type: 'GET' }, function (resp) {
				self.options.dispatcher
					.trigger('set:content', resp, 'org-activate-rendered');
				self.$('[data-chosen=True]').chosen().removeAttr('data-chosen');
				$.validator.unobtrusive.parse(self.$('form'));
			});
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.OrganizationsContent = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.OrganizationActivate(this.options)
			];
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.AccountsSettings = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:accountSettings', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/Accounts/Settings', type: 'GET' }, function (resp) {
				self.options.dispatcher
					.trigger('set:content', resp, 'account-welcome-rendered');
			});
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.AccountsWelcome = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:accountWelcome', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/Accounts/Welcome', type: 'GET' }, function (resp) {
				self.options.dispatcher
					.trigger('set:content', resp, 'account-welcome-rendered');
			});
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.AccountsContent = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.AccountsWelcome(this.options),
				new LA.Views.AccountsSettings(this.options)
			];

			_.bindAll(this, 'render');
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.HomeTermsOfService = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:homeTermsOfService', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/Help/Terms', type: 'GET' },
				function (resp) {
					self.options.dispatcher
						.trigger('set:content', resp, 'home-tos-rendered');
				});
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.HomePrivacy = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, 'render');

			this.options.dispatcher
				.on('render:homePrivacy', this.render);
		},
		render: function () {
			var self = this;

			LA.ajax({ url: LA.Path + '/Home/Privacy', type: 'GET' },
				function (resp) {
					self.options.dispatcher
						.trigger('set:content', resp, 'home-privacy-rendered');
				});
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.HomeContent = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.HomePrivacy(this.options),
				new LA.Views.HomeTermsOfService(this.options)
			];

			_.bindAll(this, 'render');
		}
	});
	/*----------------*/
	LA.Views.Folders = Backbone.View.extend({
		initialize: function (options) {
			_.bindAll(this, 'render');
			this.options = options;
			this.options.dispatcher.on('render:folders', this.render);
		},

		render: function () {
			this.options.dispatcher.trigger('reset:crumb');

			//there is conditional logic in application.js to determine if components are rendered already
			//the class needs to be removed here so components don't think they're already rendered when navigating back and forth from/to react
			$('#content').removeClass();

			ReactDOM.render(<FoldersPageContainer
				user={window.LA.User}
				permissions={window.LA.Security}
			/>, document.getElementById('content'));
			return this;
		}
	});

	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.AppContent = Backbone.View.extend($.extend(LA.Mixins.View, {
		initialize: function (options) {
			this.options = options;
			this.views = [
				new LA.Views.HomeContent(this.options),
				new LA.Views.AccountsContent(this.options),
				new LA.Views.OrganizationsContent(this.options),
				new LA.Views.PromotionsContent(this.options),
				new LA.Views.SubscribersContent(this.options),
				new LA.Views.NewsletterListContent(this.options),
				new LA.Views.NewslettersContent(this.options),
				new LA.Views.ReportsContent(this.options),
				new LA.Views.AdminContent(this.options),
				new LA.Views.SupportContent(this.options),
				new LA.Views.Folders(this.options)
			];

			_.bindAll(this, 'set', 'append', 'reset', 'removeReactComponents');

			this.options.dispatcher
				.on('set:content', this.set)
				.on('append:content', this.append)
				.on('reset:content', this.reset);
		},
		set: function (val, className, cssRules) {
			var css = $.extend({}, { margin: '0 10px' }, cssRules || {});

			if (!_.isUndefined(className) && !_.isNull(className)) {
				this.$el.removeAttr('class').addClass(className);
			}
			this.$el
				.html(val)
				.css(css);
		},
		append: function (val) {
			this.$el.append(val);
		},
		removeReactComponents: function () {
			ReactDOM.unmountComponentAtNode(document.getElementById('content'));
		},

		reset: function () {
			this.removeReactComponents();
			this.resetChildren();
			this.$el.empty();
		}
	}));
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.SideNav = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.template = options.template;

			_.bindAll(this, 'render', 'setModel', 'click', 'select', 'show', 'reset', 'getSelectedLinkTarget');

			this.options.dispatcher
				.on(options.selectEvent, this.select)
				.on(options.setEvent, this.setModel)
				.on(options.showEvent, this.show);
		},
		render: function () {
			this.$el
				.empty()
				.html(this.template(this.model.toJSON()));

			this.delegateEvents({ 'click li a': 'click' });

			this.select(this.model.get('action'));
		},
		setModel: function (obj, options) {
			var opts = $.extend({}, { clear: true, silent: false, keepSelection: false }, options || {});

			if (opts.clear) {
				this.model.clear();
			}
			this.model.set(obj);

			if (!this.model.has('action') && opts.keepSelection) {
				// Technically not the same as action, setting action to the current link target will
				// work with the jQuery selector currently in the select function.
				this.model.set({ action: this.getSelectedLinkTarget() }, { silent: true });
			}

			if (!opts.silent) {
				this.render();
			}
		},
		click: function (e) {
			var $el = $(e.currentTarget),
				$parent = $el.parent(),
				$next = $el.next(),
				subnav = $el.attr('data-subnav'),
				href,
				returnVal = true;

			if (!_.isUndefined(subnav)) {
				if (!$next.is(':visible')) {
					$next.slideDown('fast', function () {
						href = $next.find('a:first').click().attr('href');
						LA.AppRouter.navigate(href, { trigger: true });
					});
				}
				returnVal = false;
			}
			if (!$el.closest('ul').hasClass('sub-nav')) {
				$el.closest('ul').find('ul.sub-nav').not($next).slideUp('fast');
			}

			if ($parent.hasClass('selected')) {
				e.preventDefault();
				returnVal = false;
			} else {
				$parent.parent().find('li').removeClass('selected');
				$parent.addClass('selected');
			}

			return returnVal;
		},
		select: function (action) {
			var $a, $li, $ul;

			this.$('ul li.selected').removeClass('selected');
			if (action !== null) {
				$a = this.$('a[href*="' + action + '"]');
				$li = $a.parent();
				$ul = $li.parent();

				if ($ul.hasClass('sub-nav')) {
					$li.addClass('selected');
					$ul.show();
					$ul.parent().addClass('selected');
				} else {
					$li.addClass('selected');
				}
			}
		},
		getSelectedLinkTarget: function () {
			var $a = this.$('ul li.selected a');

			return $a.length > 0 ? $a.attr('href') : null;
		},
		show: function (bool) {
			if (bool) {
				this.$el.show();
			} else {
				this.$el.hide();
			}
		},
		reset: function () {
			this.undelegateEvents();
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.SectionNav = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			_.bindAll(this, "select");

			this.options.dispatcher
				.on('select:section', this.select);
		},
		select: function (val) {
				var selectReactNavBarLink = () => {
					var $currentlySelected = this.$('a.MuiLink-underlineAlways'),
						$targetToSelect = this.$('a[data-route-val="' + val + '"]');

					if ($currentlySelected.attr('data-route-val') !== $targetToSelect.attr('data-route-val')) {
						$currentlySelected.removeClass('MuiLink-underlineAlways');
						$currentlySelected.addClass('MuiLink-underlineHover');
						$targetToSelect.removeClass('MuiLink-underlineHover');
						$targetToSelect.addClass('MuiLink-underlineAlways');
					}
				};

				var targetHasLoaded = this.$('a[data-route-val="' + val + '"]').length !== 0;

				if (!targetHasLoaded) {
					//wait 0ms for the react nav bar to load into the dom
					_.delay(selectReactNavBarLink, 0);
				}
				else {
					selectReactNavBarLink();
				}
			

			var $currentlySelected = this.$('a.MuiLink-underlineAlways'),
				$targetToSelect = this.$('a[data-route-val="' + val + '"]');
			if ($currentlySelected.attr('data-route-val') !== $targetToSelect.attr('data-route-val')) {
				$currentlySelected.removeClass('MuiLink-underlineAlways');
				$currentlySelected.addClass('MuiLink-underlineHover');
				$targetToSelect.removeClass('MuiLink-underlineHover');
				$targetToSelect.addClass('MuiLink-underlineAlways');
			}
		},
		reset: function () {
			this.$('a').removeClass('selected');
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.BreadCrumb = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.templates = LA.filterTemplates(/^BreadCrumbs\/List$/);

			_.bindAll(this, 'render', 'add', 'remove', 'pop', 'reset');

			this.options.dispatcher
				.on('add:crumb', this.add)
				.on('remove:crumb', this.remove)
				.on('reset:crumb', this.reset)
				.on('pop:crumb', this.pop);

			this.collection
				.on('add', this.render)
				.on('remove', this.render)
				.on('reset', this.render);
		},
		render: function () {
			this.$el.empty();
			this.$el.html(this.templates.List({ data: this.collection.toJSON() }));
		},
		add: function (crumb, options) {
			var opts = _.extend({}, { isRoot: false }, options);

			if (opts.isRoot) {
				this.reset();
			}

			this.collection.add(new LA.Models.BreadCrumb(crumb));
		},
		remove: function (crumb) {
			this.collection.remove(new LA.Models.BreadCrumb(crumb));
		},
		pop: function (options) {
			var opts = _.extend({}, { silent: false }, options);
			this.collection.pop(opts);
		},
		reset: function () {
			this.collection.reset();
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.AppHeader = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;

			var sectionNavEl = this.$('#react-section-nav-bar');

			this.sectionNav = new LA.Views.SectionNav({ el: sectionNavEl, dispatcher: options.dispatcher });
			this.breadCrumb = new LA.Views.BreadCrumb({
				el: $('#bread-crumbs'), collection: new LA.Collections.BreadCrumbs(), dispatcher: options.dispatcher
			});

			_.bindAll(this, 'render');
		}
	});
	/*----------------*/
	/**
	 * @todo - MOVE TO OWN MODULE
	 */
	LA.Views.App = Backbone.View.extend({
		initialize: function (options) {
			this.options = options;
			this.header = new LA.Views.AppHeader({ el: $('header'), dispatcher: options.dispatcher });
			this.content = new LA.Views.AppContent({ el: $('#content'), dispatcher: options.dispatcher });

			// Set the context for all function calls of this view.
			_.bindAll(this, 'appReset');

			this.options.dispatcher
				.on('reset:app', this.appReset);
		},
		appReset: function () {
			this.options.dispatcher
				.trigger('reset:section')
				.trigger('reset:crumb')
				.trigger('reset:content');
		}
	});

	/////////////////////////////////////////////////////////////////////////////
	// Configure Router
	/////////////////////////////////////////////////////////////////////////////
	/**
 * @todo - MOVE TO OWN MODULE
 */
	LA.Routers.Main = Backbone.Router.extend(_.extend(LA.Mixins.App, {
		initialize: function (options) {
			var self = this,
				routes = [
					// TODO: DO NOT ADD NEW ROUTES HERE UNLESS ABSOLUTELY NECESSARY.  TRY TO FOLLOW THE PATTERN DEFINED IN Backbone/Routes/self_check.js.
					['!/organization/:action', 'organization'],
					['!/promotions/:status/:activity/:col/:dir/:starFilterType', 'promotions-old'],
					['!/promotions/:status/:activity/:col/:dir', 'promotions-old'],
					['!/promotions/:status/:activity/:col', 'promotions-old'],
					['!/promotions/:status/:activity', 'promotions-old'],
					['!/promotions/:status', 'promotions-old'],
					['!/promotions', 'promotions-old'],
					[/^!\/promotions\/(\d+)\/item-([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)$/, 'promotionItem'],
					// Share / Post-To / Add To Widget type routes
					[/^!\/promotions\/(\d+)\/([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)$/, 'promotion-old'],
					[/^!\/folders\/(\d+)\/([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)$/, 'promotion'],
					[/^!\/promotions\/(\d+)\/([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)$/, 'promotion-old'],
					[/^!\/folders\/(\d+)\/([a-zA-Z0-9-_\.]+?)\/([a-zA-Z0-9-_\.]+?)$/, 'promotion'],
					// Specific Folder view / action
					[/^!\/promotions\/(\d+)\/([a-zA-Z0-9-_\.]+?)$/, 'promotion-old'],
					[/^!\/folders\/(\d+)\/([a-zA-Z0-9-_\.]+?)$/, 'promotion'],
					[/^!\/promotions\/(\d+)[\/]*$/, 'promotions-old'],
					// Should we just remove this? - no one should have this bookmarked (even if they did)
					['!/promotions/create', 'createPromotion'],

					['!/subscribers/:action/:id', 'subscribers'],
					['!/subscribers/:action/filter/*filters', 'filterSubscribers'],
					['!/subscribers/:action', 'subscribers'],
					['!/subscribers', 'subscribers'],
					['!/newsletters/:id/:action/:issueId/:goBackPage/:postId', 'newsletterlists'],
					['!/newsletters/:id/:action/:issueId/:goBackPage', 'newsletterlists'],
					['!/newsletters/:id/issues/:action/:issueId', 'newsletterlists'],
					['!/newsletters/:id/:action/:issueId', 'newsletterlists'],
					['!/newsletters/:id/:action', 'newsletterlists'],
					['!/newsletters/:action', 'newsletters'],
					['!/newsletters', 'newsletters'],
					['!/newsletters/createlist', 'createNewsletterList'],
					['!/newsletters/advance-list/:action', 'advancelists'],
					['!/newsletters/advance-list', 'advancelists'],
					[/^!\/newsletters\/advance-list\/((\d{4})-([a-zA-Z]+?|\d{1,2}))$/, 'advancelists'],
					['!/reports/:action', 'reports'],
					['!/reports', 'reports'],
					['!/admin/:action/:id', 'admin'],
					['!/admin/:action', 'admin'],
					['!/admin/widgets/:type/:action/:id/:promoId', 'widgets'],
					['!/admin/widgets/:type/:action/:id', 'widgets'],
					['!/admin/widgets/:type/:action', 'widgets'],
					['!/admin/widgets/:type', 'widgets'],
					["!/admin/widgets", 'widgets'],
					['!/admin', 'admin'],
					['!/support/:action/:id', 'support'],
					['!/support/:action', 'support'],
					['!/support', 'support'],
					['!/account/:action', 'account'],
					['!/account', 'account'],
					['!/privacy', 'home'],
					['!/tos', 'home'],
					['', 'defaultRoute'],
					['!/folders', 'foldersRoute'],
					['!/folders/', 'foldersRoute'],
					['!/folders/:action', 'foldersRoute'],
				];

			self.routesHit = 0;

			_.each(routes, function (route) {
				self.route.apply(self, route);
			});

			_.bindAll(self, 'goBack');

			self.on('all', function (eventName) {
				if (eventName.indexOf('route:') === 0) {
					// Count routes hit so when know when we can use window.history and when to navigate to a static page.
					self.routesHit++;
				}
			});

			this.options = options;
		},
		goBack: function (defaultUrl) {
			if (this.routesHit > 1) {
				window.history.back();
			} else {
				this.navigate(defaultUrl, { trigger: true });
			}
		}
	}));
	/*----------------*/
	LA.AppRouter = new LA.Routers.Main(_.extend({}, LA.Mixins.App, { dispatcher: LA.Events.Aggregator }));

	// TODO: Try not to handle new routes here.  Follow the pattern defined in Backbone/Routes/self_check.js.

	/*----------------*/

	LA.AppRouter.on('route:foldersRoute',
		function () {
			this.options.dispatcher
				.trigger('select:section', Constants.NAV_LINK_FOLDERS.toLowerCase())
				.trigger('render:folders');
		});
	// Define router functions
	LA.AppRouter.on('route:organization', function (action) {
		this.options.dispatcher
			.trigger('select:section', null)
			.trigger('add:crumb', { text: 'Home', fragment: '#!/promotions' }, { isRoot: true });

		if (action === 'activate') {
			this.options.dispatcher
				.trigger('add:crumb', { text: 'Activate Organization' })
				.trigger('render:orgActivate');
		} else {
			this.navigate("!/promotions", { trigger: true });
		}
	});
	/*----------------*/
	LA.AppRouter.on('route:promotions-old', function (folderId) {
		const folderUrl = folderRouteBuilder(folderId)
		LA.AppRouter.navigate(folderUrl,
			this.trigger('route:foldersRoute'));
	});
	LA.AppRouter.on('route:promotions', function (status, activity, col, dir, starFilterType) {
		var values = {
			status: ((_.isUndefined(status) || _.isNull(status)) ? 2 : (status === 'active' ? 2 : 3)),
			activity: (_.isUndefined(activity) ? 5 : (activity === 'created' ? 1 : 5)),
			sort: (_.isUndefined(col) ? 4 : (col === 'name' ? 1 : 4)),
			dir: (_.isUndefined(dir) ? 2 : (dir === 'asc' ? 1 : 2)),
			starFilterType: starFilterType,
			page: 1
		};

		if (!this.isRendered('promos-list-rendered')) {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', 'promotions')
				.trigger('add:crumb', { text: 'Folders', fragment: '#!/folders' })
				.trigger('add:crumb', { text: 'All Folders' })
				.trigger('render:promosList');
		}

		if (Res.Values.Promos.promoCount > 0) {
			$('#search').keyup();
		}

		this.options.dispatcher
			.trigger('set:promofilter', values);

	});
	/*----------------*/
	LA.AppRouter.on('route:createPromotion', function () {
		this.options.dispatcher
			.trigger('reset:app')
			.trigger('select:section', 'promotions')
			.trigger('add:crumb', { text: 'Promotions', fragment: '#!/promotions' })
			.trigger('add:crumb', { text: 'Create Promotion' })
			.trigger('render:promosCreate');
	});
	/*----------------*/
	/**
	 * @description - Here we support the "old" route, but forward onto the new route
	 * this preserves bookmark experiences. We have a few handlers here, while redundant, it
	 * is easy to digest. 
	 */
	LA.AppRouter.on('route:promotion-old', function (promoId, action, type, id) {
		const folderPath = folderRouteBuilder(promoId, action, type, id)
		window.location.hash = folderPath;
	});


	LA.AppRouter.on('route:promotion', function (promoId, action, type, id) {
		// Default
		if (_.isUndefined(action)) {
			action = 'existing-items';
		}

		if (!this.isRendered('promos-dashboard-rendered')) {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', 'promotions')
				.trigger('render:promoDashboard', promoId, action);
		}

		// Determine if the nav column should be displayed or not.
		if (action === 'create-item') {
			this.options.dispatcher
				.trigger('resize:promoLayout', false);
		} else {
			this.options.dispatcher
				.trigger('resize:promoLayout', true);
		}

		// Get promotion definition.
		this.options.dispatcher
			.trigger('fetch:promoModel', promoId, action, type, id);
	});
	/*----------------*/
	LA.AppRouter.on('route:promotionItem', function (promoId, action, id) {
		// I am not real sure what this does.... but it is here for backwards compatibility
		this.trigger('route:promotion', promoId, action, null, id);
	});
	/*----------------*/
	LA.AppRouter.on('route:filterSubscribers', function (action, filters) {
		if (!this.isRendered('subscribers-dashboard-rendered') || action === 'email' || action === 'deactivated') {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_SUBSCRIBERS.toLowerCase())
				.trigger('render:subscriberDashboard', action);
		}

		this.options.dispatcher
			.trigger('render:subscriberCrumbsAndChild', action, null, filters);
	});
	/*----------------*/
	LA.AppRouter.on('route:subscribers', function (action, id) {
		// Default
		if (_.isUndefined(action) || _.isNull(action)) {
			action = 'email';
		}

		if (!this.isRendered('subscribers-dashboard-rendered') || action === 'email') {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_SUBSCRIBERS.toLowerCase())
				.trigger('render:subscriberDashboard', action);
		}

		this.options.dispatcher
			.trigger('render:subscriberCrumbsAndChild', action, id);
	});
	/*----------------*/
	LA.AppRouter.on('route:createNewsletterList', function () {
		this.options.dispatcher
			.trigger('reset:app')
			.trigger('select:section', Constants.NAV_LINK_NEWSLETTERS.toLowerCase())
			.trigger('add:crumb', { text: 'Newsletters', fragment: '#!/newsletters' })
			.trigger('add:crumb', { text: 'Create Newsletter List' })
			.trigger('render:newsletterListCreate');
	});
	/*----------------*/
	LA.AppRouter.on('route:newsletters', function (action, id) {
		// Default
		if (_.isUndefined(action) || _.isNull(action)) {
			action = 'overview';
		}
		if (!this.isRendered('newsletters-dashboard-rendered') || action === "overview") {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_NEWSLETTERS.toLowerCase())
				.trigger('render:newslettersDashboard', action);
		}

		this.options.dispatcher
			.trigger('render:newslettersCrumbsAndChild', action, id);

	});
	var getMonth = function (monthStr) {
		///<summary>Returns the numerical month for the given month string.
		///		Valid return values are 1-12, 1 representing january, 12 representing december.
		///		Note that this is NOT compatible with JavaScript dates, where 0 is January and 11 is December.
		///</summary>
		/// <param name="monthStr" type="String">the textual month, case insensitive ("Jan", "January", "Feb", etc)</param>
		var month = 1;//default to January, if it can't be parsed
		if (monthStr) {
			monthStr = monthStr.toLowerCase();

			switch (monthStr) {
				case "jan":
				case "january":
					month = 1;
					break;
				case "feb":
				case "february":
					month = 2;
					break;
				case "mar":
				case "march":
					month = 3;
					break;
				case "apr":
				case "april":
					month = 4;
					break;
				case "may":
					month = 5;
					break;
				case "jun":
				case "june":
					month = 6;
					break;
				case "jul":
				case "july":
					month = 7;
					break;
				case "aug":
				case "august":
					month = 8;
					break;
				case "sept":
				case "september":
					month = 9;
					break;
				case "oct":
				case "october":
					month = 10;
					break;
				case "nov":
				case "november":
					month = 11;
					break;
				case "dec":
				case "december":
					month = 12;
					break;
			}
			return month;
		}
	};
	LA.AppRouter.on('route:advancelists', function (action, year, month) {
		// Default
		var defaultAction = "advance-list";
		if (_.isUndefined(action) || _.isNull(action)) {
			action = defaultAction;
		} else if (year && month) {
			action = defaultAction;
			year = parseInt(year, 10);
			month = parseInt(month, 10) || getMonth(month);
		}
		if (!this.isRendered('newsletters-dashboard-rendered')) {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_NEWSLETTERS.toLowerCase())
				.trigger('render:newslettersDashboard', action);
		}

		this.options.dispatcher
			.trigger('render:newslettersCrumbsAndChild', action, year, month);

	});
	/*----------------*/
	LA.AppRouter.on('route:reports', function (action) {
		// Default action
		if (_.isUndefined(action) || _.isNull(action)) {
			action = 'schedule';
		}
		if (!this.isRendered('reports-dashboard-rendered') || action === 'schedule') {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_REPORTS.toLowerCase())
				.trigger('render:reportsDashboard', action);
		}

		this.options.dispatcher
			.trigger('render:reportsCrumbsAndChild', action);
		//		.trigger('resize:reportsLayout', false)

	});
	/*----------------*/

	//important: call this function so that this is the global object in the route handler
	//ie: renderAdminDashboard.call(this, action);
	var renderAdminDasboard = function (action) {
		if (!this.isRendered('admin-dashboard-rendered') || action === 'settings') {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_ADMIN.toLowerCase())
				.trigger('render:adminDashboard', action);
		}
	};

	LA.AppRouter.on('route:admin', function (action, id) {
		// Default
		if (_.isUndefined(action) || _.isNull(action)) {
			action = 'settings';
		}
		renderAdminDasboard.call(this, action);

		// Determine if the nav column should be displayed or not.
		if (action === 'copy-template') {
			this.options.dispatcher
				.trigger('resize:adminLayout', false);
		} else {
			this.options.dispatcher
				.trigger('resize:adminLayout', true);
		}

		this.options.dispatcher
			.trigger('render:adminCrumbsAndChild', action, id);
	});


	LA.AppRouter.on('route:widgets', function (type, action, id, promoId) {
		type = (type || "promotion").toLowerCase();
		//this is a subsection of admin, so render the admin dashboard
		renderAdminDasboard.call(this, "widgets/" + type);
		this.options.dispatcher.trigger('render:adminWidgetSubsection', type, action, id, promoId);
	});
	/*----------------*/
	LA.AppRouter.on('route:support', function (action, id, query) {

		// Default
		if (_.isUndefined(action) || _.isNull(action)) {
			action = 'organizations';
		}

		if (!this.isRendered('support-dashboard-rendered')) {
			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', null)
				.trigger('render:supportDashboard', action);
		}

		// TODO: Fix this method of passing in the query parameters
		// Backbone changed the way they handle query parameters in 0.9.9 and 1.1.1 from being part of a parameter
		// to being their own separate parameter. To keep the old code working, I am converting it to work the old way
		// for the time being.
		// See https://github.com/jashkenas/backbone/issues/891

		this.options.dispatcher
			.trigger('render:supportCrumbsAndChild', action, id + "?" + query);
	});
	/*----------------*/
	LA.AppRouter.on('route:account', function (action) {
		this.options.dispatcher
			.trigger("reset:app")
			.trigger('select:section', null)

		switch (action) {
			case 'welcome':
				this.options.dispatcher
					.trigger('add:crumb', { text: 'Welcome to LibraryAware' })
					.trigger('render:accountWelcome');
				break;
			case 'settings':
				this.options.dispatcher
					.trigger('render:accountSettings');
				break;
			default:
				this.navigate("!/promotions", { trigger: true });
				break;
		}
	});
	/*----------------*/
	LA.AppRouter.on('route:home', function () {
		var action = window.location.hash.split('/')[1];

		this.options.dispatcher
			.trigger('select:section', null)
			.trigger('add:crumb', { text: 'Home', fragment: '#!/promotions' }, { isRoot: true });

		switch (action) {
			case 'privacy':
				this.options.dispatcher
					.trigger('add:crumb', { text: 'Privacy Policy' })
					.trigger('render:homePrivacy');
				break;
			case 'tos':
				this.options.dispatcher
					.trigger('add:crumb', { text: 'Terms of Service' })
					.trigger('render:homeTermsOfService');
				break;
			default:
				this.navigate("!/promotions", { trigger: true });
				break;
		}
	});

	/**
	 * @description Performs some fail-safe checking for the User.DefaultTab value.
	 * @returns {string} The default tab value
	 */
	function GetDefaultTabFromUserObject() {
		var derivedDefaultTab = window.Res.Values.User.DefaultTab;
		// guard against a null or undefined
		return derivedDefaultTab ? derivedDefaultTab : "folders"
	}

	LA.AppRouter.on('route:defaultRoute', function () {
		this.navigate("!/" + GetDefaultTabFromUserObject(), { trigger: true });
	});

	// add route handler for newsletterlists route event
	// this will cover editing/viewing lists and all issues since they all fall under the same dashboard
	LA.AppRouter.on('route:newsletterlists', function (id, action, issueId, goBackPage, postId) {

		// Go to overview by default
		if (_.isUndefined(action) || _.isNull(action)) {
			action = 'overview';
		}

		// if we have not already navigated to the list dashboard and rendered it
		// do so now, otherwise just render the crumbs and child

		if (!this.isRendered('newsletterList-dashboard-rendered')) {
			// reset the application
			// select the newsletters top navigation button
			// trigger the event to load the left side navigation for the lists
			// the template for the left side nav (found in _jst.cshtml)
			// requires the list id to build the links on the left side.  so we pass that
			// as one of the arguments when raising the event


			this.options.dispatcher
				.trigger('reset:app')
				.trigger('select:section', Constants.NAV_LINK_NEWSLETTERS.toLowerCase())
				.trigger('render:newsletterListDashboard', action, id)
				// we need to get newsletter list details in order to display the crumbs properly (list name)
				// since we need to make sure we DO NOT load our crumbs and child before we get our details,
				// we load our crumbs and children on success of details acquisition
				.trigger('get:newsletterListDetails', action, id, issueId, goBackPage, postId);
		} else {
			// raise the event to render the action found in the fragment of the url for the lists
			// pass the id of the list, the action found in the fragment (if any) and the id of the
			// issue found in the fragment (if any)

			this.options.dispatcher
				.trigger('render:newsletterListCrumbsAndChild', action, id, issueId, goBackPage, postId);
		}



	});

	LA.AppRouter.popBreadCrumb = function () {
		this.options.dispatcher.trigger("pop:crumb");
	};

	//Trigger the app to start once the DOM is good to go.
	$(function () {

		const $jst = $('#_jst');
		$('script.tmpl', $jst).each(function () {
			LA.Templates[this.id] = _.template($(this).html());
		});

		// Init main view
		LA.App = new LA.Views.App({ el: $('body'), dispatcher: LA.Events.Aggregator });

		// Start Backbone history, necessary for bookmarkable URL's
		Backbone.history.start();

			ReactDOM.render(
				<LibraryAwareTheme>
					<NavBarMain
						orgId={window.LA.OrganizationId}
						user={window.LA.User}
						userPermissions={window.LA.Security}
						homeViewEnabled={window.LibraryAware.HomeViewEnabled}
						errorPage={window.LibraryAware.NotificationError}
					/>
				</LibraryAwareTheme>, document.getElementById('react-section-nav-bar'));
		
	});
}
